import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  Card as BootstrapCard,
  OverlayTrigger,
  Tooltip as ReactTooltip,
  Popover as ReactPopover,
} from "react-bootstrap";
import { useBlocker } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { RotatingLines } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import { useParams } from "react-router-dom";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import { useMemo } from "react";
import { Plus } from "lucide-react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, TextField, Popover, Typography, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import FocusError from "../../../components/error/error-focus";
import InputField from "../../../components/input/input-field";
import FadeLoaderComponent from "../../../components/loader-component";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  Package2,
  Grid3X3,
  CheckCircle,
  XCircle,
  AlertTriangle,
  AlertCircle,
  Eye,
  Edit,
  Package,
  X,
  DeleteIcon,
  ChevronRight,
} from "lucide-react";
import SearchInput from "../../../components/search-input";
import { ThreeDots } from "react-loader-spinner";
import { useUnsavedChanges } from "./unsaveChanges";
import { Badge, Container } from "react-bootstrap";
import { ArrowLeft, Grid3x3, MapPin, PackageCheck } from "lucide-react";
import { roleTypes } from "../../../data/roleType";
import RackAdd from "./createRackModal";

const HistoryCard = ({ item }) => {
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}/${year} ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <Card style={{ width: "40vw" }}>
      <div
        className="border-2 shadow-sm"
        style={{ transition: "box-shadow 0.2s" }}
      >
        <div className="d-flex flex-row p-3 p-sm-4">
          <div style={{ width: "70%" }}>
            <div className="">
              <div
                className="text-capitalize fw-bold mb-1"
                style={{ fontSize: "0.875rem" }}
              >
                {item.type}
                <span className={`fw-bold text-capitalize`}>
                  {" "}
                  {item.type === "order"
                    ? "Received"
                    : item.type === "job" && item.job === "Job Unassigned"
                      ? "Unassigned"
                      : "Changed"}
                  <span
                    className="text-muted text-normal fw-normal small mb-0"
                    style={{ fontSize: "0.875rem" }}
                  >
                    {" "}
                    (by {item.name})
                  </span>
                </span>
              </div>
              <p
                className="text-muted fw-normal small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Status{" "}
                <span
                  className={`fw-bold text-capitalize ${item.status === "active" || item.status === "installed"
                    ? "text-success"
                    : item.status === "damaged"
                      ? "text-danger"
                      : "text-dark"
                    }`}
                >
                  {item.status}
                </span>
              </p>
            </div>
          </div>

          <div style={{ width: "30%" }}>
            <div className="text-muted small mb-1">Date:</div>
            <div className="text-muted small mb-1">
              {formatDateTime(item.date)}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between text-capitalize align-items-start px-3 px-sm-4 pb-3 pb-sm-4">
          <div style={{ width: "70%" }}>
            <div className="text-muted small mb-1">
              {" "}
              From:{" "}
              <span
                className="text-muted small   mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                {item?.type === "order" && "PO# "}
                {item.received_from}
              </span>
            </div>

            <div className="text-muted text-capitalize small mb-1">
              To:{" "}
              <span
                className="text-muted small  mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                {item?.received_to}
              </span>
            </div>
          </div>

          <div style={{ width: "30%" }}>
            <div className="text-muted small mb-1">
              <span
                className="text-muted small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Job: {item.job === "Job Unassigned" ? "N/A" : item.job}
              </span>
            </div>
            <div className="text-muted small mb-1">
              <span
                className="text-muted small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Warehouse: {item.warehouse_name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

const statusOptions = [
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "in-active", label: "Inactive" },
  { value: "damaged", label: "Damaged" },
];

const colors = [
  {
    status: "active",
    color: "bg-primary",
  },
  {
    status: "in-active",
    color: "bg-warning",
  },
  {
    status: "blocked",
    color: "bg-danger",
  },
  {
    status: "pending",
    color: "bg-info",
  },
];

const RackBinModal = ({
  show,
  onHide,
  selectedRackProduct,
  warehouseProducts,
  token,
  decodedToken,
  handleBinAssignToWarehouseProduct,
  setSelectedRackProduct,
  alerts: alertResponse,
  setAlertResponse,
}) => {
  const { id } = useParams();
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const currentLocationRef = useRef(null);

  const [currentView, setCurrentView] = useState("racks");
  const [loader, setLoader] = useState(true);
  const [selectedRack, setSelectedRack] = useState(null);
  const [selectedBins, setSelectedBins] = useState(null);
  const [allRacks, setAllRacks] = useState([]);
  const [filteredRacks, setFilteredRacks] = useState([]);
  const [bins, setBins] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(12);
  const [searchTerm, setSearchTerm] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [alerts, setAlerts] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const totalPages = Math.ceil(filteredRacks.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const paginatedRacks = filteredRacks.slice(startIndex, endIndex);

  const filterRacks = useCallback((racks, search) => {
    if (!search || search.trim().length < 2) {
      return racks;
    }

    const searchLower = search.toLowerCase().trim();

    return racks.filter((rack) => {
      const nameMatch = rack.name?.toLowerCase().includes(searchLower);
      const numberMatch = rack.rack_number?.toLowerCase().includes(searchLower);
      const descMatch = rack.description?.toLowerCase().includes(searchLower);

      return nameMatch || numberMatch || descMatch;
    });
  }, []);

  useEffect(() => {
    const filtered = filterRacks(allRacks, searchTerm);
    setFilteredRacks(filtered);
    setCurrentPage(1);
  }, [searchTerm, allRacks, filterRacks]);

  const getWarehouseRacks = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setLoader(false);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.post(
        `${url.backendURL}warehouse/${id}/racks/active`,
        {},
        config
      );

      const racksData = response?.data?.response?.data || [];
      setAllRacks(racksData);
      setFilteredRacks(racksData);
      setLoader(false);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      handleError(err, "warehouses-racks");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (show && currentView === "racks" && isInitialLoad) {
      setLoader(true);
      getWarehouseRacks();
      setIsInitialLoad(false);
    }
  }, [show, currentView, isInitialLoad]);

  useEffect(() => {
    if (show && currentLocationRef.current && paginatedRacks.length > 0) {
      setTimeout(() => {
        currentLocationRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }
  }, [show, paginatedRacks]);

  useEffect(() => {
    if (!show) {
      setCurrentView("racks");
      setSelectedRack(null);
      setSelectedBins(null);
      setSearchTerm("");
      setCurrentPage(1);
      setIsInitialLoad(true);
      setAllRacks([]);
      setFilteredRacks([]);
    }
  }, [show]);

  const handleError = (err, alertFor) => {
    const { response } = err;

    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setAlerts({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        if (response?.data?.message === "Warehouse not found") {
          window.location.href = "/dashboard/app/warehouse-list";
        }
        setAlerts({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const [rackBinLoader, setRackBinLoader] = useState(true);

  const getWarehouseRackBins = async (rackId) => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setRackBinLoader(false);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    const requestBody = {
      productId: selectedRackProduct?.id,
    };

    try {
      const response = await axios.post(
        `${url.backendURL}warehouse/${id}/racks/${rackId}/active`,
        requestBody,
        config
      );
      const data = response?.data?.response?.data;
      setBins(data[0]?.bins || []);
      setRackBinLoader(false);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "warehouses-rack-bin-edit");
    } finally {
      setRackBinLoader(false);
    }
  };

  const handleRackClick = async (rack) => {
    setSelectedRack(rack);
    setCurrentView("bins");
    setRackBinLoader(true);
    setSelectedBins(null);
    await getWarehouseRackBins(rack.rack_id);
  };

  const handleBackToRacks = () => {
    setSelectedRack(null);
    setSelectedBins(null);
    setCurrentView("racks");
  };

  const handleModalClose = () => {
    setCurrentView("racks");
    setSelectedRack(null);
    setSelectedBins(null);
    setSearchTerm("");
    setCurrentPage(1);
    onHide();
  };

  const [animatingId, setAnimatingId] = useState(null);
  const handleBinClick = async (binId, containsSelectedProduct) => {
    if (selectedRackProduct?.id) {
      const bin = bins.find((b) => b.id === binId);
      if (bin) {
        setAnimatingId(binId);
        await handleBinAssignToWarehouseProduct(
          selectedRack,
          bin,
          containsSelectedProduct
        );
        setAnimatingId(null);
        setSelectedBins(binId);
      } else {
        setSelectedBins(null);
      }
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "active":
        return <CheckCircle size={16} className="text-success" />;
      case "in-active":
        return <XCircle size={16} className="text-danger" />;
      case "damaged":
        return <AlertCircle size={16} className="text-danger" />;
      case "filled":
        return <PackageCheck size={16} className="text-primary" />;
      default:
        return <CheckCircle size={16} className="text-secondary" />;
    }
  };

  const binContainsSelectedProduct = (binId) => {
    return selectedRackProduct?.default_bin_id === binId;
  };

  const getBinProduct = (binId) => {
    if (binContainsSelectedProduct(binId)) {
      return {
        id: selectedRackProduct.id,
        product_name: selectedRackProduct.name || "Selected Product",
        quantity: selectedRackProduct.product_quantity || 0,
      };
    }
    return null;
  };

  const rackContainsSelectedProduct = (rackId) => {
    return selectedRackProduct?.rack_id === rackId;
  };

  const generateBinGrid = (rack) => {
    const grid = [];

    for (let row = rack.total_rows; row >= 1; row--) {
      for (let col = 1; col <= rack.total_columns; col++) {
        const bin = bins.find(
          (b) => b.row_number === row && b.column_number === col
        );
        if (bin) {
          let binProduct = getBinProduct(bin.id);
          if (!binProduct) {
            const binProductMatch = warehouseProducts.find((product) => {
              if (!product.default_bin_id) return false;

              const isSameBin = product.default_bin_id === bin.id;

              const isSameWarehouseProduct =
                product.id === selectedRackProduct?.id;

              return isSameBin && !isSameWarehouseProduct;
            });

            if (binProductMatch) {
              binProduct = {
                id: binProductMatch.id,
                product_name: binProductMatch.name,
                quantity: binProductMatch.product_quantity || 0,
              };
            }
          }
          grid.push({
            row,
            col,
            id: bin.id,
            bin: bin,
            product: binProduct,
            hasProduct: !!binProduct,
            status: bin.status,
            key: `${row}-${col}`,
          });
        }
      }
    }
    return grid;
  };

  const permissions = useSelector(SettingSelector.set_permissions);
  const rackManagementHasCreatePermission =
    permissions?.rack_management?.create === true;

  const LoadingSpinner = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        minHeight: "400px",
        padding: "2rem",
      }}
    >
      <ThreeDots
        height="60"
        width="60"
        radius="9"
        color="#3a57e8"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={true}
      />
      <p className="text-muted mt-3 mb-0">Loading...</p>
    </div>
  );

  const handleAddNewRack = () => {
    setCurrentView(null);
    setSelectedRackProduct(null);
    onHide(false);
    const url = `/dashboard/app/rack-add?id=${id}`;
    window.open(url, "_blank");
  };

  const NoRacksFound = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        minHeight: "400px",
        padding: "2rem",
      }}
    >
      <Package2 className="text-muted mb-3" size={64} />
      <h4 className="text-dark mb-2">No Racks Found</h4>
      <p className="text-muted mb-3">
        {searchTerm ? (
          <>
            No racks match your search criteria. Try adjusting your search terms
            {(rackManagementHasCreatePermission ||
              decodedToken?.roles?.some(
                (role) => role.role_type === roleTypes.SUPER_ADMIN
              )) && (
                <>
                  {" or "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddNewRack();
                    }}
                    className="text-primary text-decoration-none"
                    style={{
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    Install Racks
                  </a>
                </>
              )}
          </>
        ) : (
          <>
            There are no racks available in this warehouse,
            {(rackManagementHasCreatePermission ||
              decodedToken?.roles?.some(
                (role) => role.role_type === roleTypes.SUPER_ADMIN
              )) && (
                <>

                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddNewRack();
                    }}
                    className=" text-decoration-none"
                    style={{
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    {" "}click here{" "}
                  </a>
                  to install some racks
                </>
              )}
          </>
        )}
      </p>
    </div>
  );

  const NoBinsFound = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        minHeight: "400px",
        padding: "2rem",
      }}
    >
      <Package2 className="text-muted mb-3" size={64} />
      <h4 className="text-dark mb-2">No Bins Found</h4>
      <p className="text-muted mb-0">This rack doesn&apos;t have any bins.</p>
    </div>
  );

  const RacksView = () => (
    <div style={{ minHeight: "400px" }}>
      {loader ? (
        <LoadingSpinner />
      ) : paginatedRacks?.length > 0 ? (
        <Row className="g-3 mt-2">
          {paginatedRacks.map((rack) => {
            const hasSelectedProduct = rackContainsSelectedProduct(
              rack.rack_id
            );
            const isCurrentlySelected = selectedRack?.rack_id === rack.rack_id;
            const isActive = hasSelectedProduct || isCurrentlySelected;
            const [showTooltip, setShowTooltip] = useState(null);
            const [showStatusOverlay, setShowStatusOverlay] = useState(null);

            const tooltipStyle = (rackId) => ({
              position: "absolute",
              bottom: "calc(100% + 10px)",
              left: "20%",
              transform: "translateX(-50%)",
              backgroundColor: "#1f2937",
              color: "white",
              padding: "0.5rem 0.75rem",
              borderRadius: "6px",
              fontSize: "0.8rem",
              fontWeight: "500",
              whiteSpace: "normal",
              zIndex: 1000,
              opacity: showTooltip === rackId ? 1 : 0,
              visibility: showTooltip === rackId ? "visible" : "hidden",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              width: "auto",
            });

            const tooltipArrowStyle = {
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid #1f2937",
            };

            return (
              <Col
                xs={12}
                sm={6}
                md={6}
                xl={4}
                key={rack.id}
                onClick={() => {
                  if (rack.status === "active") {
                    handleRackClick(rack);
                  }
                }}
                onMouseEnter={() => {
                  setHoveredCard(rack.id);
                  if (rack.status !== "active") {
                    setShowStatusOverlay(true);
                  }
                }}
                onMouseLeave={() => {
                  setHoveredCard(null);
                  setShowStatusOverlay(false);
                }}
                ref={hasSelectedProduct ? currentLocationRef : null}
              >
                <Card
                  style={{
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    borderRadius: "16px",
                    height: "200px",
                    transform: isActive
                      ? "translateY(-8px) scale(1.05)"
                      : "translateY(0) scale(1)",
                    cursor:
                      rack.status !== "active" ? "not-allowed" : "pointer",
                    border: "2px solid",
                    opacity:
                      rack.status !== "active" && showStatusOverlay ? 0.7 : 1,
                    pointerEvents: rack.status !== "active" ? "none" : "auto",
                    borderColor: isActive ? "#3a57e8" : "transparent",
                    position: "relative",
                    filter: rack.status !== "active" ? "blur(0px)" : "none",
                  }}
                  className="h-100 shadow-sm"
                >
                  {hasSelectedProduct && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-1rem",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 10,
                      }}
                    >
                      <Badge
                        bg="primary"
                        style={{
                          fontSize: "0.7rem",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "12px",
                          fontWeight: "600",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      >
                        Current Location
                      </Badge>
                    </div>
                  )}

                  {isCurrentlySelected && !hasSelectedProduct && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        zIndex: 10,
                      }}
                    >
                      <Badge
                        bg="primary"
                        style={{
                          fontSize: "0.7rem",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "12px",
                          fontWeight: "600",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      >
                        Selected
                      </Badge>
                    </div>
                  )}

                  {rack.status !== "active" && (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: "50%",
                          backgroundColor: "#ffffff66",
                          borderRadius: "16px 16px 0 0",
                          zIndex: 20,
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "50%",
                          backgroundColor: "#ffffff66",
                          borderRadius: "0 0 16px 16px",
                          zIndex: 20,
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          zIndex: 21,
                          width: "50%",
                          maxWidth: "100px",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#dc3545",
                            padding:
                              "clamp(0.8rem, 0.8vw, 0.8rem) clamp(0rem, 1vw, 0rem)",
                            borderRadius: "8px",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: "clamp(0.60rem, 1.4vw, 0.60rem)",
                              textTransform: "uppercase",
                              letterSpacing: "0.4px",
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {rack.status.replace("-", " ")}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <Card.Body
                    className="p-3 d-flex flex-column position-relative"
                    style={{ minHeight: "176px" }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center mb-4"
                      style={{ height: "64px" }}
                    >
                      <div
                        className="d-flex align-items-start gap-2 flex-grow-1"
                        style={{ minWidth: 0 }}
                      >
                        <div
                          className="mt-auto p-2 rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            backgroundColor:
                              hasSelectedProduct || isCurrentlySelected
                                ? "#3a57e8"
                                : "#198754",
                            width: "36px",
                            height: "36px",
                          }}
                        >
                          <Grid3x3 size={18} className="text-white" />
                        </div>
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div
                            style={{ position: "relative" }}
                            onMouseEnter={() => setShowTooltip(rack.id)}
                            onMouseLeave={() => setShowTooltip(null)}
                          >
                            <h6
                              className="mb-1 fw-bold text-dark"
                              style={{
                                fontSize: "0.95rem",
                                whiteSpace: "nowrap",
                                overflowX: "auto",
                                overflowY: "hidden",
                                maxWidth: "90%",
                                cursor: "help",
                                lineHeight: "1.2",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                WebkitScrollbar: "none",
                                marginTop: "8px",
                              }}
                              ref={(el) => {
                                if (el) {
                                  el.style.setProperty(
                                    "-webkit-scrollbar",
                                    "none",
                                    "important"
                                  );
                                }
                              }}
                            >
                              {rack.name}
                            </h6>
                            <div style={tooltipStyle(rack.id)}>
                              {rack.name}
                              <div style={tooltipArrowStyle}></div>
                            </div>
                          </div>
                          <small
                            className="text-muted fw-medium d-block"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: "1.2",
                            }}
                          >
                            {rack.rack_number}
                          </small>
                        </div>
                      </div>
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0 "
                        style={{ paddingTop: "2px" }}
                        title={rack.status === "in-active" && "In-active"}
                      >
                        {getStatusIcon(rack.status)}
                      </div>
                    </div>

                    <div className="row g-2 mb-3" style={{ height: "60px" }}>
                      <div className="col-6">
                        <div className="text-center p-2 bg-light rounded-3 h-100 d-flex flex-column justify-content-center">
                          <div
                            className="fw-bold text-primary h6 mb-0"
                            style={{ fontSize: "1rem" }}
                          >
                            {rack.total_rows}
                          </div>
                          <small
                            className="text-muted fw-medium"
                            style={{ fontSize: "0.75rem" }}
                          >
                            Rows
                          </small>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center p-2 bg-light rounded-3 h-100 d-flex flex-column justify-content-center">
                          <div
                            className="fw-bold text-primary h6 mb-0"
                            style={{ fontSize: "1rem" }}
                          >
                            {rack.total_columns}
                          </div>
                          <small
                            className="text-muted fw-medium"
                            style={{ fontSize: "0.75rem" }}
                          >
                            Columns
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="mt-auto" style={{ height: "40px" }}>
                      <Button
                        variant={
                          rack.status === "in-active"
                            ? "outline-primary"
                            : "outline-primary"
                        }
                        size="sm"
                        className="w-100 h-100 d-flex align-items-center justify-content-center gap-2"
                        disabled={rack.status === "in-active"}
                        style={{
                          borderRadius: "10px",
                          fontWeight: "500",
                          fontSize: "0.85rem",
                          cursor:
                            rack.status === "in-active"
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            rack.status === "in-active" ? "transparent" : "",
                        }}
                        onClick={() => {
                          if (rack.status === "active") {
                            handleRackClick(rack);
                          }
                        }}
                      >
                        <Eye size={14} />
                        View Details
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <NoRacksFound />
      )}
    </div>
  );

  const BinsView = () => {
    if (!selectedRack) return null;

    const binGrid = generateBinGrid(selectedRack);

    useEffect(() => {
      if (currentLocationRef.current && binGrid.length > 0) {
        currentLocationRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, [binGrid.length]);

    return (
      <div style={{ minHeight: "400px" }}>
        {rackBinLoader ? (
          <LoadingSpinner />
        ) : binGrid?.length > 0 ? (
          <div
            className="d-grid gap-3"
            style={{
              gridTemplateColumns: `repeat(${selectedRack.total_columns}, 1fr)`,
              maxWidth: `${selectedRack.total_columns * 160}px`,
            }}
          >
            {binGrid.map((cell) => {
              const isSelected = selectedBins === cell.id;
              const hasProduct = cell.hasProduct;
              const containsSelectedProduct = binContainsSelectedProduct(
                cell.id
              );
              const isAnimating = animatingId === cell.id;
              const filledBin =
                !containsSelectedProduct &&
                cell.hasProduct &&
                cell.product.id !== selectedRackProduct.id;
              return (
                <div
                  key={cell.key}
                  ref={containsSelectedProduct ? currentLocationRef : null}
                  className={`relative bin-cell
                    ${cell.status === "active" ? "position-active" : ""}
                                  ${cell.status === "in-active"
                      ? "position-inactive"
                      : ""
                    }
                                  ${cell.status === "damaged"
                      ? "position-damaged"
                      : ""
                    }
                                   ${cell.hasProduct ? "position-fill" : ""}
                    ${isAnimating ? "animating" : ""} ${isSelected ? "selected" : ""
                    }`}
                  onClick={async () => {
                    if (
                      cell.status === "active" &&
                      (hasProduct === false || containsSelectedProduct)
                    ) {
                      await handleBinClick(cell.id, containsSelectedProduct);
                    }
                  }}
                  style={{
                    minHeight: "140px",

                    borderRadius: "12px",
                    transition: "all 0.3s ease",
                    cursor:
                      cell.bin.status === "active" &&
                        (!cell.hasProduct || containsSelectedProduct)
                        ? "pointer"
                        : "not-allowed",
                    border: isAnimating
                      ? "3px solid transparent"
                      : isSelected
                        ? "3px solid #0d6efd"
                        : containsSelectedProduct
                          ? "3px solid #3a57e8"
                          : cell.status === "damaged"
                            ? "3px solid #dc3545"
                            : cell.status === "in-active"
                              ? "3px solid #212529"
                              : cell.status === "active"
                                ? "3px solid #28a745"
                                : "",
                    backgroundColor:
                      (!containsSelectedProduct &&
                        cell.hasProduct &&
                        cell.product.id !== selectedRackProduct.id) ||
                        cell.status !== "active"
                        ? ""
                        : isSelected
                          ? "#f8f9ff"
                          : containsSelectedProduct
                            ? "#fff5f5"
                            : "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    boxShadow: isAnimating
                      ? ""
                      : isSelected || containsSelectedProduct
                        ? "0 4px 20px rgba(13, 110, 253, 0.2)"
                        : "0 2px 8px rgba(0,0,0,0.06)",
                    transform:
                      isSelected || containsSelectedProduct
                        ? "translateY(-2px)"
                        : "translateY(0)",
                  }}
                >
                  {isAnimating && (
                    <div
                      style={{
                        position: "absolute",
                        top: 2,
                        left: 2,
                        right: 2,
                        bottom: 2,
                        backgroundColor: "rgba(255, 255, 255, 0.03)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                        borderRadius: "12px",
                      }}
                    >
                      <RotatingLines
                        strokeWidth="4"
                        animationDuration="0.75"
                        width="40"
                        strokeColor="#0d6efd"
                        color="#0d6efd"
                        visible={true}
                      />
                    </div>
                  )}
                  <div
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      zIndex: 1,
                    }}
                    title={
                      cell.bin.status === "in-active"
                        ? "In-active bin"
                        : cell.bin.status === "damaged"
                          ? "Damaged bin"
                          : cell.bin.status === "active" &&
                          !cell.hasProduct &&
                          !isSelected &&
                          !containsSelectedProduct &&
                          "Active Bin"
                    }
                  ></div>
                  <div className="text-center mb-2">
                    <div className="">
                      <span className="small fw-bold text-dark">
                        Row{cell.row} Col
                        {cell.col}
                      </span>
                    </div>
                  </div>

                  <div className="text-center">
                    {(isSelected && selectedRackProduct) || cell.product ? (
                      <div>
                        <span className={`product-name`}>
                          {cell.product?.product_name}
                        </span>
                        <div className="border-success">
                          <span className="quantity-text">
                            Qty: {cell.product?.quantity}
                          </span>
                        </div>
                      </div>
                    ) : containsSelectedProduct ? (
                      <div>
                        <div
                          className="fw-medium text-dark mb-1"
                          style={{ fontSize: "0.8rem", lineHeight: "1.2" }}
                        >
                          {selectedRackProduct.name}
                        </div>
                        <small className="text-muted">
                          Qty: {selectedRackProduct.product_quantity}
                        </small>
                      </div>
                    ) : cell.bin.status === "active" ? (
                      <div
                        className="text-muted fw-medium"
                        style={{ fontSize: "0.75rem" }}
                      >
                        Click to choose
                      </div>
                    ) : (
                      <div
                        className="text-muted fw-medium"
                        style={{ fontSize: "0.75rem" }}
                      >
                        <span
                          className={`product-name ${cell.bin.status === "damaged"
                            ? "text-danger fw-bold"
                            : cell.bin.status === "in-active"
                              ? "text-danger fw-bold"
                              : ""
                            }`}
                        >
                          {cell.bin.status === "in-active"
                            ? "In-active bin"
                            : cell.bin.status === "damaged" && "Damaged bin"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <NoBinsFound />
        )}
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleModalClose}
      backdrop="true"
      dialogClassName="modal-responsive-width"
      keyboard={true}
    >
      <Modal.Header className="custom-modal-header ">
        <Modal.Title className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            <div className="p-2 bg-opacity-10 rounded-3">
              {currentView === "bins" ? (
                <ArrowLeft
                  size={32}
                  onClick={handleBackToRacks}
                  className="text-primary"
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <MapPin size={26} className="text-primary" />
              )}
            </div>
            <div className="d-flex flex-column">
              <span className="fw-bold fs-4 text-dark">
                {currentView === "racks"
                  ? "Warehouse Racks"
                  : `${selectedRack?.name} - ${selectedRack?.rack_number}`}
              </span>
              <span className="fs-6 text-muted fw-normal">
                {currentView === "racks" ? (
                  selectedRackProduct?.id ? (
                    <>
                      Select a rack to choose a bin location for the product{" "}
                      <strong>{selectedRackProduct.name}</strong>
                    </>
                  ) : (
                    "Select a rack to view its bin layout"
                  )
                ) : selectedRackProduct?.id ? (
                  <>
                    Choose a bin location for product{" "}
                    <strong>{selectedRackProduct.name}</strong>
                  </>
                ) : (
                  "Click on any bin position to select it"
                )}
              </span>
            </div>
          </div>
        </Modal.Title>
        <button
          type="button"
          className="btn-close-svg"
          onClick={handleModalClose}
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      </Modal.Header>

      <Modal.Body
        className="p-0"
        style={{
          height: "75vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Search Section - Fixed at top */}
        {currentView === "racks" && (
          <div className="px-4 border-bottom">
            <Card className="border-0 mb-0">
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col lg={12}>
                    <Row className="g-2">
                      <Col sm={6}>
                        <div className="position-relative w-50">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search racks..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                      </Col>

                      <Col
                        sm={6}
                        className="d-flex ps-0 ps-sm-4 justify-content-start justify-content-md-end align-items-center"
                      >
                        {(rackManagementHasCreatePermission ||
                          decodedToken?.roles?.some(
                            (role) => role.role_type === roleTypes.SUPER_ADMIN
                          )) && (
                            <>
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleAddNewRack();
                                }}
                                className="mt-1 mt-md-0 items-end"
                              >
                                <Button
                                  type="submit"
                                  variant="btn btn-primary"
                                  className=" responsive-button"
                                >
                                  Add New Rack
                                </Button>
                              </Link>
                            </>
                          )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        )}

        {currentView === "bins" && (
          <div className="px-4 border-bottom">
            <Card className="border-0 mb-0">
              <Card.Body className="p-4">
                <Row>
                  <Col lg={8}>
                    <div className="d-flex align-items-center gap-4">
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2 border-success me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Active</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2 border-dark me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Inactive</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2 border-danger me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Damage</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2  border-success position-active position-fill me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Fill</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2  border-primary position-active position-fill me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Current</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              {alertResponse.alertFor === "bin-list" && (
                <AlertNotificationSimple
                  type={alertResponse.type}
                  message={alertResponse.message}
                  show={alertResponse.show}
                  onClose={() =>
                    setAlertResponse({ ...alertResponse, show: false })
                  }
                />
              )}
            </Card>
          </div>
        )}
        {/* Content Section - Scrollable */}
        <div
          className="flex-grow-1 px-4 py-3"
          style={{
            overflowY: "auto",
            flex: "1 1 auto",
          }}
        >
          <Container fluid className="px-0">
            {currentView === "racks" ? <RacksView /> : <BinsView />}
          </Container>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const WarehouseEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [animatingRows, setAnimatingRows] = useState(new Set());
  const [movingProducts, setMovingProducts] = useState(new Set());
  const [dragPopoverAnchor, setDragPopoverAnchor] = useState(null);
  const [dragPopoverOpen, setDragPopoverOpen] = useState(false);
  const [openRackModal, setOpenRackModal] = useState(false);
  const [selectedRackProduct, setSelectedRackProduct] = useState(null);
  const alertRef = useRef(null);
  const alertRefProduct = useRef(null);
  const [isSubmitProduct, setIsSubmitProduct] = useState(true);
  const [isSubmitRack, setIsSubmitRack] = useState(true);
  const [itemsLoader, setItemsLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [warehouse, setWarehouse] = useState();
  const [errors, setErrors] = useState({});
  const [activeJobs, setActiveJobs] = useState([]);
  const [quantityError, setQuantityError] = useState();
  const [minQuantityError, setMinQuantityError] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalWarehouseProductsRecords, setTotalWarehouseProductsRecords] =
    useState(0);
  const [binError, setBinError] = useState();
  const [type, setType] = useState(null);
  const [decodedToken, setDecodedToken] = useState();
  const [showHistoryView, setShowHistoryView] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const token = localStorage.getItem("coyote-token");
  const [oldWarehouseProducts, setOldWarehouseProducts] = useState([]);
  const [warehouseProducts, setWarehouseProducts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState([]);
  const [histories, setHistories] = useState([]);
  const permissions = useSelector(SettingSelector.set_permissions);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [warehouseProductsPagination, setWarehouseProductsPagination] =
    useState({
      pageIndex: 0,
      pageSize: 10,
    });

  const [globalFilter, setGlobalFilter] = useState("");
  const [warehouseProductsGlobalFilter, setWarehouseProductsGlobalFilter] =
    useState("");

  const hasUpdatePermission = permissions?.warehouse?.update === true;
  const hasImportViewPermission =
    permissions?.warehouse?.view_warehouse_product === true;
  const hasImportUpdatePermission =
    permissions?.warehouse?.import_product === true;
  const hasAssignBinLocationPermission =
    permissions?.warehouse?.fill_product_into_bin === true;
  const hasFillProductViewPermission =
    permissions?.warehouse?.view_product_bin === true;
  const hasFillProductUpdatePermission =
    permissions?.warehouse?.fill_product_into_bin === true;
  const hasImportDeletePermission = permissions?.warehouse?.delete === true;
  const rackManagementHasCreatePermission =
    permissions?.rack_management?.create === true;
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);

  const searchTimeoutRef = useRef(null);
  const currentSearchRequestRef = useRef(null);

  const handlePageChange = (pageNumber) => {
    if (totalEntries === 0) return;
    setCurrentPage(pageNumber);
  };

  const [showUnsaveModal, setShowUnsaveModal] = useState(false);

  const handleUnsaveClose = () => {
    setShowUnsaveModal(false);
  };

  const handleUnsaveShow = () => setShowUnsaveModal(true);

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [alerts, setAlerts] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const [selectedProductRows, setSelectedProductRows] = useState([]);
  const [selectedWarehouseOption, setSelectedWarehouseOption] = useState(null);

  const getImportProducts = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    } else if (type) {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          warehouseId: type,
        },
      };

      try {
        const response = await axios.get(
          `${url.backendURL}product/type`,
          config
        );
        const allProducts = response.data.response.data;
        setTotalRecords(allProducts.length || 0);
        if (type === "receiving") {
          if (warehouseProducts && warehouseProducts?.length) {
            const filteredProducts = allProducts.filter(
              (product) =>
                !warehouseProducts?.some(
                  (warehouseProduct) => warehouseProduct.id === product.id
                )
            );
            setProducts(filteredProducts);
          } else {
            setProducts(allProducts);
          }
        } else {
          const filteredProducts = allProducts.map((product) => ({
            ...product,
            moved: false,
            warehouse_id: type,
            product_warehouse: true,
          }));
          setProducts(filteredProducts);
        }
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        handleError(err, "products");
      }
    }
  };

  const getWarehouses = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    } else {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      try {
        const response = await axios.get(
          `${url.backendURL}warehouse/${id}/all`,
          config
        );
        setWarehouses(response.data.response.data);
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        // handleError(err, "products");
      }
    }
  };

  const getActiveJobs = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    } else {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      try {
        const response = await axios.get(
          `${url.backendURL}warehouse/${id}/jobs/active`,
          config
        );
        setActiveJobs(response.data.response.data);
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        // handleError(err, "products");
      }
    }
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getWarehouse = async () => {
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}warehouse/${id}/detail`,
        config
      );
      const warehouse = response.data.response.data;
      setWarehouse(warehouse);

      // Temporary fix for live server MariaDB
      setOldWarehouseProducts(warehouse?.products);

      // Temporary fix for live server MariaDB
      setWarehouseProducts(
        warehouse?.products && warehouse?.products.length > 0
          ? warehouse.products.map((product) => ({
            ...product,
            product_selection: "own",
            old_product_quantity: product.product_quantity || 0,
            new_product_quantity: 0,
            old_default_bin_id: product.default_bin_id,
            old_rack_id: product.rack_id,
          }))
          : []
      );

      // Temporary fix for live server MariaDB
      setLoader(false);
      return warehouse;
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      if (
        err.response.data.message ===
        "You are not allowed to update this warehouse"
      ) {
        window.location.href = "/dashboard/app/warehouse-list";
      }
      handleError(err, "information");
      setLoader(false);
    }
  };

  const getWarehouseProductDetail = async () => {
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}warehouse/${id}/detail`,
        config
      );
      const warehouse = response.data.response.data;

      // Temporary fix for live server MariaDB
      setOldWarehouseProducts(warehouse?.products);

      // Temporary fix for live server MariaDB
      setWarehouseProducts(
        warehouse?.products && warehouse?.products.length > 0
          ? warehouse.products.map((product) => ({
            ...product,
            product_selection: "own",
            old_product_quantity: product.product_quantity || 0,
            new_product_quantity: 0,
            old_default_bin_id: product.default_bin_id,
            old_rack_id: product.rack_id,
          }))
          : []
      );
      // setWarehouseProducts(processedProducts || []);
      setTotalWarehouseProductsRecords(warehouse.products.length || 0);
      return warehouse;
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "products");
    }
  };

  const [racks, setRacks] = useState([]);
  const [filteredRacks, setFilteredRacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);

  const [selectedRack, setSelectedRack] = useState(null);
  const [selectedRackBin, setSelectedRackBin] = useState(null);
  const [rackBins, setRackBins] = useState({});
  const [showRackModal, setShowRackModal] = useState(false);
  const [showRackBinModal, setShowRackBinModal] = useState(false);
  const [showRackAddModal, setShowRackAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const getWarehouseRacks = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setLoader(false);

      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}warehouse/${id}/racks`,
        config
      );

      setRacks(response?.data?.response?.data || []);
      setFilteredRacks(response?.data?.response?.data || []);
      setTotalEntries(response?.data?.response?.warehouse_racks_count || 0);
    } catch (err) {
      if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
        return;
      }

      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } finally {
      setLoader(false);
    }
  };
  const applyFilters = useCallback(() => {
    let filtered = [...racks];

    if (searchTerm && searchTerm.trim().length >= 2) {
      const searchLower = searchTerm.toLowerCase().trim();
      filtered = filtered.filter(
        (rack) =>
          rack.name.toLowerCase().includes(searchLower) ||
          rack.rackNumber.toLowerCase().includes(searchLower)
      );
    }

    if (statusFilter && statusFilter !== "all") {
      filtered = filtered.filter((rack) => rack.status === statusFilter);
    }

    setFilteredRacks(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  }, [racks, searchTerm, statusFilter]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, statusFilter, applyFilters]);

  // Monitor selectedProductRows for changes
  useEffect(() => {
    if (selectedProductRows.length > 0) {
      setHasUnsavedChanges(true);
    } else {
      setHasUnsavedChanges(false);
    }
  }, [selectedProductRows]);

  const { showModal, confirmNavigation, cancelNavigation, message } =
    useUnsavedChanges({
      hasUnsavedChanges,
      message:
        "You have selected products that haven't been saved. Are you sure you want to leave?",
    });
  // Block navigation when there are unsaved changes
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
  );

  // Handle beforeunload event for page refresh/close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  // Handle blocked navigation
  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(true);
      setPendingNavigation(() => blocker.proceed);
    }
  }, [blocker.state]);

  const handleDiscardChanges = useCallback(() => {
    if (blocker.state === "blocked") {
      setHasUnsavedChanges(false);
      setSelectedProductRows([]);
      setWarehouseProducts(oldWarehouseProducts || []);

      if (type && type !== null) {
        getImportProducts();
      }

      if (products && products.length > 0) {
        setProducts((prevProducts) =>
          prevProducts.map((product) => ({
            ...product,
            moved: false,
            isSelected: false,
            warehouse_product_quantity:
              product.quantity || product.warehouse_product_quantity,
          }))
        );
      }

      setQuantityError(null);
      setMinQuantityError(null);
      setBinError(null);
      setErrors({});
      setIsSubmitProduct(true);
      setWarehouseProductSubmit(false);
      setAnimatingRows(new Set());
      setMovingProducts(new Set());
      setIsTable2Open(false);
      setSelectedRackProduct(null);
      setSelectedWarehouseOption(null);
      setShowDiscardModal(false);

      if (pendingNavigation) {
        pendingNavigation();
        setPendingNavigation(null);
      } else if (blocker.proceed) {
        blocker.proceed();
      }
    }
  }, [
    blocker.state,
    pendingNavigation,
    blocker,
    oldWarehouseProducts,
    type,
    getImportProducts,
  ]);

  const handleCancelDiscard = useCallback(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    setShowDiscardModal(false);
    setPendingNavigation(null);
  }, [blocker.state, blocker]);

  useEffect(() => {
    if (
      decodedToken?.roles?.some(
        (role) => role.role_type === roleTypes.SUPER_ADMIN
      ) ||
      hasFillProductUpdatePermission ||
      hasFillProductViewPermission
    ) {
      getWarehouseRacks();
    }
  }, [token, decodedToken, id]);

  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const displayedRacks = filteredRacks.slice(startIndex, endIndex);

  const checkImportProductUpdate = async () => {
    if (selectedProductRows.length > 0) {
      for (const newProd of selectedProductRows) {
        if (newProd.new_status === "added") {
          return false;
        }
      }
    }

    return true;
  };
  const filterWarehouseProducts = (warehouseProducts, searchValue) => {
    if (!searchValue || searchValue.trim() === "") {
      return warehouseProducts;
    }

    const searchWords = searchValue
      .toLowerCase()
      .trim()
      .replace(/[-+]/g, "")
      .split(/\s+/);

    return warehouseProducts.filter((product) => {
      const searchableText = (
        product.warehouse_aggregated_search_text ||
        product.searchable_text ||
        ""
      ).toLowerCase();

      return searchWords.every((word) => searchableText.includes(word));
    });
  };

  const getPaginatedData = (data, pageIndex, pageSize) => {
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  };

  const getWarehouseProductsPaginatedData = (data, pageIndex, pageSize) => {
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    const data = {
      name: values.name,
      address: values.address,
      type: values.type,
    };
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.put(
        `${url.backendURL}warehouse/${values.id}/warehouse-information`,
        data,
        config
      );
      setWarehouse({
        ...warehouse,
        name: values.name,
        address: values.address,
        type: values.type,
      });
      resetForm({
        values: {
          id: values.id,
          name: values.name,
          identityNumber: values.identityNumber,
          type: values.type,
          address: values.address,
        },
      });
      setErrors({});
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setAlerts({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "information",
      });
      setTimeout(() => {
        setAlerts({ show: false, alertFor: "", message: "", type: "" });
      }, 2000);
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "information");
    } finally {
      setSubmitting(false);
    }
  };

  const [warehouseProductSubmit, setWarehouseProductSubmit] = useState(false);
  const handleSubmitProduct = async (e) => {
    e.preventDefault();
    setQuantityError(null);
    setMinQuantityError(null);
    setBinError(null);
    const productsToAdd = [];
    const productsToRemove = [];
    if (selectedProductRows.length > 0) {
      selectedProductRows.forEach((newProd) => {
        const existingProd = oldWarehouseProducts?.find(
          (oldProd) => oldProd.id === newProd.id
        );

        if (existingProd && newProd.new_status === "removed") {
          productsToRemove.push({
            id: newProd.id,
            status: "removed",
            new_product_quantity: newProd.new_product_quantity,
            product_min_quantity_notify: newProd.product_min_quantity_notify,
            warehouse_id: newProd.warehouse_id || null,
            default_bin_id:
              newProd.default_bin_id || newProd.old_default_bin_id,
          });
        } else if (
          existingProd &&
          newProd.new_status === "added" &&
          (newProd.new_product_quantity > 0 ||
            newProd.product_min_quantity_notify !==
            existingProd.product_min_quantity_notify ||
            newProd.warehouse_id !== existingProd.warehouse_id ||
            newProd.default_bin_id !== existingProd.default_bin_id)
        ) {
          productsToAdd.push({
            id: newProd.id,
            status: "added",
            new_product_quantity: newProd.new_product_quantity,
            product_min_quantity_notify: newProd.product_min_quantity_notify,
            warehouse_id: newProd.warehouse_id || null,
            default_bin_id:
              newProd.default_bin_id || newProd.old_default_bin_id || null,
          });
        } else if (!existingProd && newProd.new_status === "added") {
          productsToAdd.push({
            id: newProd.id,
            status: "added",
            new_product_quantity: newProd.new_product_quantity,
            product_min_quantity_notify: newProd.product_min_quantity_notify,
            warehouse_id: newProd.warehouse_id || null,
            default_bin_id:
              newProd.default_bin_id || newProd.old_default_bin_id || null,
          });
        }
      });
    }
    const payload = {
      products: [...productsToAdd, ...productsToRemove],
    };
    let isValid = true;
    if (payload?.products?.length > 0) {
      selectedProductRows.forEach((newProd) => {
        const existingProd = oldWarehouseProducts?.find(
          (oldProd) => oldProd.id === newProd.id
        );
        const matchedProduct = products?.find((p) => p.id === newProd.id);
        if (
          newProd.warehouse_id &&
          matchedProduct &&
          Number(newProd.new_product_quantity) > Number(matchedProduct.quantity)
        ) {
          setIsSubmitProduct(true);
          setWarehouseProductSubmit(false);
          setQuantityError(
            `Import quantity ${newProd.new_product_quantity
            } cannot exceed available quantity ${matchedProduct.quantity} for ${matchedProduct.name || "this product"
            }.`
          );

          if (alertRefProduct.current) {
            alertRefProduct.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }

          isValid = false;
          return;
        }
        if (
          !existingProd &&
          newProd.new_status === "added" &&
          (newProd.new_product_quantity < 1 ||
            newProd.product_min_quantity_notify === 0)
        ) {
          setIsSubmitProduct(true);
          setWarehouseProductSubmit(false);
          if (newProd.new_product_quantity < 1) {
            setQuantityError("Import quantity must be greater than 0");
          }
          if (newProd.product_min_quantity_notify === 0) {
            setMinQuantityError(
              "Minimum quantity notify must be greater than 0"
            );
          }

          if (alertRefProduct.current) {
            alertRefProduct.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          isValid = false;
          return;
        }

        if (
          existingProd &&
          newProd.new_status === "added" &&
          newProd.warehouse_id &&
          newProd.new_product_quantity < 1
        ) {
          setIsSubmitProduct(true);
          setWarehouseProductSubmit(false);
          setQuantityError("Import quantity must be greater than 0");

          if (alertRefProduct.current) {
            alertRefProduct.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          isValid = false;
          return;
        }

        if (newProd.new_status === "added" && !newProd.default_bin_id) {
          if (!newProd.old_default_bin_id) {
            setIsSubmitProduct(true);
            setWarehouseProductSubmit(false);
            setBinError("You must assign a bin for the imported products");

            if (alertRefProduct.current) {
              alertRefProduct.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
            isValid = false;
            return;
          }
        }
      });
    }

    if (isValid && payload?.products.length > 0) {
      setQuantityError("");
      setMinQuantityError("");
      setBinError("");
      try {
        const config = {
          headers: {
            Authorization: `${token}`,
          },
        };

        const response = await axios.put(
          `${url.backendURL}warehouse/${id}/warehouse-product`,
          payload,
          config
        );
        await getWarehouseProductDetail();
        setHasUnsavedChanges(false);

        setErrors({});
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        if (type) {
          await getImportProducts();
        }
        setIsTable2Open(false);
        setSelectedProductRows([]);
        setAlerts({
          message: response.data.message,
          type: "success",
          show: true,
          alertFor: "products",
        });
        setTimeout(() => {
          setAlerts({ show: false, alertFor: "", message: "", type: "" });
        }, 2000);
        setIsSubmitProduct(true);
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        handleError(err, "products");
        setIsSubmitProduct(true);
      }
    } else {
      setWarehouseProductSubmit(false);
    }

    setIsSubmitProduct(true);
    setWarehouseProductSubmit(false);
  };

  const handleError = (err, alertFor, alertType) => {
    const { response } = err;

    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      if (
        err?.response?.data?.message !==
        "You are not allowed to update this warehouse"
      ) {
        setAlerts({
          message: response ? response.data.message : "An error occurred",
          type: alertType || "danger",
          show: true,
          alertFor,
        });
        setTimeout(() => {
          if (response?.data?.message === "Warehouse not found") {
            window.location.href = "/dashboard/app/warehouse-list";
          }
          setAlerts({ show: false, alertFor: "", message: "", type: "" });
        }, 5000);
      }
    }
  };

  const resetFormData = (resetForm) => {
    resetForm();
  };

  const validationSchema = () =>
    Yup.object().shape({
      name: Yup.string()
        .trim()
        .min(1, "Name must be at least 1 character long")
        .max(255, "name must not exceed 255 characters")
        .required("Name is required")
        .matches(
          /^(?=.*[a-zA-Z])[a-zA-Z0-9 '&.-]*$/,
          "Warehouse name can only contain letters and numbers"
        ),
      identityNumber: Yup.string()
        .trim()
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Identity number must contain at least one letter or number"
        )
        .max(100, "Identity number must not exceed 100 characters")
        .required("Identity number is required"),
      address: Yup.string()
        .trim()
        .min(1, "Address must be at least 1 character long")
        .max(255, "Address must not exceed 255 characters")
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Address must contain at least one letter or number"
        )
        .required("Address is required"),
      type: Yup.string()
        .oneOf(["physical", "van"], "Type must be either 'physical' or 'van'")
        .required("Type is required"),
    });

  const addProductToWarehouse = (product) => {
    if (type === null) {
      setSelectedProductRows((prevSelectedProductRows) => {
        const existingProductIndex = prevSelectedProductRows?.findIndex(
          (item) => item.id === product.id
        );

        const isProductSameAsOld = oldWarehouseProducts?.some(
          (oldProd) =>
            oldProd.id === product.id &&
            oldProd.warehouse_id === product.warehouse_id &&
            oldProd.new_product_quantity === product.new_product_quantity &&
            oldProd.product_min_quantity_notify ===
            product.product_min_quantity_notify &&
            oldProd.default_bin_id === product.default_bin_id
        );

        if (isProductSameAsOld) {
          if (existingProductIndex !== -1) {
            const updatedProductRows = [...prevSelectedProductRows];
            updatedProductRows.splice(existingProductIndex, 1);
            return updatedProductRows;
          }
          return prevSelectedProductRows;
        }

        if (existingProductIndex === -1) {
          const updatedProductRowsNew = [
            {
              ...product,
              new_status: "added",
            },
            ...prevSelectedProductRows,
          ];

          return updatedProductRowsNew;
        }

        if (existingProductIndex !== -1) {
          const updatedProductRows = [...prevSelectedProductRows];
          updatedProductRows[existingProductIndex] = {
            ...updatedProductRows[existingProductIndex],
            new_status: "added",
          };
          return updatedProductRows;
        }

        const updatedProductRowsNew = [
          {
            ...product,
            new_status: "added",
          },
          ...prevSelectedProductRows,
        ];

        return updatedProductRowsNew;
      });
    } else {
      setSelectedProductRows((prevSelectedProductRows) => {
        const existingProductIndex = prevSelectedProductRows?.findIndex(
          (item) => item.id === product.id
        );

        const warehouseProduct = warehouseProducts?.find(
          (p) => p.id === product.id
        );

        const isAlreadyImported =
          warehouseProduct?.product_selection === "warehouse" &&
          warehouseProduct?.warehouse_id;
        if (existingProductIndex !== -1) {
          const source =
            warehouseProduct || prevSelectedProductRows[existingProductIndex];
          const updatedProduct = {
            ...prevSelectedProductRows[existingProductIndex],
            ...product,
            new_product_quantity:
              prevSelectedProductRows[existingProductIndex]
                .new_product_quantity || 0,
            product_min_quantity_notify:
              prevSelectedProductRows[existingProductIndex]
                .product_min_quantity_notify || 0,
            product_selection: product?.product_warehouse
              ? "warehouse"
              : product?.product_selection,
            default_bin_id: null,
            rack_id: null,
            rack_name: null,
            rack_number: null,
            row_number: null,
            column_number: null,
            new_status: "added",
          };

          const isProductSameAsOld = oldWarehouseProducts?.some(
            (oldProd) =>
              oldProd.id === updatedProduct?.id &&
              oldProd.warehouse_id === updatedProduct?.warehouse_id &&
              oldProd.new_product_quantity ===
              updatedProduct?.new_product_quantity &&
              oldProd.product_min_quantity_notify ===
              updatedProduct?.product_min_quantity_notify &&
              oldProd?.product_selection ===
              updatedProduct?.product_selection &&
              oldProd?.default_bin_id === updatedProduct?.default_bin_id
          );

          if (isProductSameAsOld || isAlreadyImported) {
            const updatedProductRows = [...prevSelectedProductRows];
            updatedProductRows.splice(existingProductIndex, 1);
            return updatedProductRows;
          } else {
            const updatedRows = [...prevSelectedProductRows];
            updatedRows[existingProductIndex] = updatedProduct;
            return updatedRows;
          }
        } else {
          if (isAlreadyImported) {
            return prevSelectedProductRows;
          }

          return [
            {
              ...product,
              ...warehouseProduct,
              new_product_quantity: warehouseProduct?.new_product_quantity || 0,
              product_min_quantity_notify:
                warehouseProduct?.product_min_quantity_notify || 0,
              product_selection: product?.product_warehouse
                ? "warehouse"
                : product?.product_selection,
              default_bin_id: warehouseProduct?.default_bin_id || null,
              column_number: warehouseProduct?.column_number || null,
              row_number: warehouseProduct?.row_number || null,
              rack_name: warehouseProduct?.rack_name || null,
              rack_number: warehouseProduct?.rack_number || null,
              rack_id: warehouseProduct?.rack_id || null,
              new_status: "added",
            },
            ...prevSelectedProductRows,
          ];
        }
      });
    }
  };

  const updateProductInWarehouse = (productId, value, key, product) => {
    const isProductSameAsOld = (newProd) => {
      const oldProduct = oldWarehouseProducts?.find(
        (oldProd) => oldProd.id === newProd.id
      );
      if (!oldProduct) return false;

      return (
        oldProduct.new_product_quantity === newProd.new_product_quantity &&
        oldProduct.product_min_quantity_notify ===
        newProd.product_min_quantity_notify &&
        oldProduct.default_bin_id === newProd.default_bin_id
      );
    };

    setSelectedProductRows((prevSelectedProductRows) => {
      const existingProduct = prevSelectedProductRows.find(
        (item) => item.id === productId
      );
      if (existingProduct) {
        const updatedProduct = {
          ...existingProduct,
          [key]: Number(value) || 0,
        };

        if (isProductSameAsOld(updatedProduct)) {
          return prevSelectedProductRows.filter(
            (item) => item.id !== productId
          );
        } else {
          return prevSelectedProductRows.map((item) =>
            item.id === productId ? updatedProduct : item
          );
        }
      } else {
        return [
          {
            ...product,
            [key]: Number(value) || 0,
            new_status: "added",
          },
          ...prevSelectedProductRows,
        ];
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          ) ||
          hasImportUpdatePermission
        ) {
          await getWarehouses();
        }
        await getWarehouse();
        if (
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          ) ||
          hasFillProductUpdatePermission ||
          hasFillProductViewPermission
        ) {
          await getWarehouseRacks();
        }
      } catch (err) {
        setLoader(false);
      }
    };
    fetchData();
  }, [decodedToken]);

  const getColorByStatus = (status) => {
    const colorObject = colors.find((color) => color.status === status);
    return colorObject ? colorObject.color : "";
  };

  const [selectedItemProduct, setSelectedItemProduct] = useState(null);
  const [selectedItemProductId, setSelectedItemProductId] = useState(null);
  const [viewProduct, setViewProduct] = useState(true);
  const [productItems, setProductItems] = useState([]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (selectedProductRows.length > 0) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [selectedProductRows]);

  const submitNotes = async (
    newNotes,
    itemId,
    setIsSubmittingNotes,
    setSuccessNotesLoader,
    setNoteValue,
    setErrorNotesLoader,
    isSubmittingNotes,
    cell,
    itemProduct
  ) => {
    if (isSubmittingNotes) return;

    try {
      setIsSubmittingNotes(true);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const data = {
        notes: newNotes,
      };
      await axios.put(
        `${url.backendURL}warehouse/${id}/products/${itemProduct.id}/item/${itemId}`,
        data,
        config
      );

      setIsSubmittingNotes(false);
      setSuccessNotesLoader(true);
      setTimeout(() => {
        setSuccessNotesLoader(false);
      }, 5000);
    } catch (err) {
      if (alertRefProduct.current) {
        alertRefProduct.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "products");
      setNoteValue(cell.getValue() || "");
      setErrorNotesLoader(true);
      setIsSubmittingNotes(false);
      setIsSubmittingNotes(false);
    }
  };

  const getProductItems = async (product, itemLoaderDisable) => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    } else {
      if (!itemLoaderDisable) {
        setItemsLoader(true);
      }
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      try {
        const response = await axios.get(
          `${url.backendURL}warehouse/${id}/items/${product.id}`,
          config
        );
        const allItems = response.data.response.data;
        setSelectedItemProductId(product.id);
        setProductItems(allItems);
        setItemsLoader(false);
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          setProductItems([]);
        }
        setItemsLoader(false);

        handleError(err, "products");
      }
    }
  };

  const handleItemsClick = async (product) => {
    setViewProduct(false);
    setItemsLoader(true);
    await getActiveJobs();
    await getProductItems(product);
  };

  const handleItemsClose = () => {
    setSelectedItemProduct(null);
    setViewProduct(true);
    setProductItems([]);
    setShowHistoryView(false);
    setSelectedHistory([]);
  };

  useEffect(() => {
    if (type) {
      getImportProducts();
    }
  }, [type]);

  const handleCancelImportProduct = async (product) => {
    const isProductImportFromWarehouse = (newProd) => {
      const oldProduct = warehouseProducts?.find(
        (oldProd) => oldProd.id === newProd.id
      );

      return (
        oldProduct &&
        oldProduct.product_selection === "warehouse" &&
        oldProduct.warehouse_id
      );
    };

    const importedProduct = isProductImportFromWarehouse(product);
    setSelectedProductRows((prevSelectedProductRows) => {
      const existingProductIndex = prevSelectedProductRows?.findIndex(
        (item) => item.id === product.id
      );

      const warehouseProduct = warehouseProducts?.find(
        (p) => p.id === product.id
      );

      if (existingProductIndex !== -1) {
        const selectedProductData =
          prevSelectedProductRows[existingProductIndex];

        const oldProduct = oldWarehouseProducts?.find(
          (oldProd) => oldProd.id === selectedProductData?.id
        );

        const isSameAsOld =
          oldProduct &&
          oldProduct.product_min_quantity_notify ===
          selectedProductData?.product_min_quantity_notify;
        if (isSameAsOld) {
          const updatedProductRows = [...prevSelectedProductRows];
          updatedProductRows.splice(existingProductIndex, 1);
          return updatedProductRows;
        } else if (oldProduct) {
          const updatedRows = [...prevSelectedProductRows];
          updatedRows[existingProductIndex] = {
            ...selectedProductData,
            warehouse_id: null,
            new_product_quantity: 0,
            product_selection: "own",
            moved: false,
          };
          return updatedRows;
        } else {
          const updatedRows = [...prevSelectedProductRows];
          updatedRows.splice(existingProductIndex, 1);
          return updatedRows;
        }
      } else {
        return [
          {
            ...product,
            ...warehouseProduct,
            warehouse_id: null,
            new_product_quantity: 0,
            product_selection: "own",
            moved: false,
          },
          ...prevSelectedProductRows,
        ];
      }
    });
    if (importedProduct) {
      setWarehouseProducts((prev) =>
        prev
          .map((p) => {
            if (p.id === product.id) {
              const oldProduct = oldWarehouseProducts?.find(
                (op) => op.id === p.id
              );

              if (!oldProduct) {
                return null;
              }

              return {
                ...p,
                new_product_quantity: oldProduct.new_product_quantity ?? 0,
                product_selection: oldProduct.product_selection ?? null,
                moved: false,
              };
            }
            return p;
          })
          .filter(Boolean)
      );

      setProducts((prev) => {
        const exists = prev.find((p) => p.id === product.id);
        if (exists) {
          return prev.map((p) =>
            p.id === product.id ? { ...p, moved: false, isSelected: false } : p
          );
        } else {
          return [
            {
              ...product,
              moved: false,
              isSelected: false,
            },
            ...prev,
          ];
        }
      });
    }
  };

  const handleProductMinQuantityNotifyChange = (productId, value, cell) => {
    updateProductInWarehouse(
      productId,
      value,
      "product_min_quantity_notify",
      cell.row.original
    );
    setWarehouseProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? { ...product, product_min_quantity_notify: Number(value) }
          : product
      )
    );
  };
  const handleProductQuantityChange = useCallback(
    (productId, newQuantity, cell) => {
      updateProductInWarehouse(
        productId,
        newQuantity,
        "new_product_quantity",
        cell.row.original
      );

      setWarehouseProducts((prev) => {
        const matchingProduct = prev.find((item) => item.id === productId);

        if (matchingProduct) {
          const updatedQuantity =
            (matchingProduct.product_selection === "warehouse" &&
              Number(newQuantity)) ||
            0;

          const diff = updatedQuantity;
          if (type !== null && type !== "receiving" && diff > -1) {
            setProducts((prev) =>
              prev.map((item) => {
                if (item.id === productId && item.moved) {
                  return {
                    ...item,
                    warehouse_product_quantity: item.quantity - diff,
                  };
                }
                return item;
              })
            );
          }

          return prev.map((item) =>
            item.id === productId
              ? {
                ...item,
                new_product_quantity: updatedQuantity,
              }
              : item
          );
        }

        return prev;
      });
    },
    []
  );

  const checkImportProductQuantity = async (id) => {
    const matchingRows = selectedProductRows.filter((row) => row.id === id);

    if (matchingRows.length === 0) {
      return true;
    }

    for (const row of matchingRows) {
      if (row.new_status === "added" && row.new_product_quantity > 0) {
        return false;
      }
    }

    return true;
  };

  const warehouseProductColumns = useMemo(
    () => [
      // { accessorKey: "id", header: "ID", size: 100 },
      {
        accessorKey: "old_product_quantity",
        header: "Quantity",
        size: 100,
        Cell: ({ cell }) => {
          const quantity = cell.getValue();
          return (
            <TextField
              type="text"
              min={0}
              value={quantity || 0}
              disabled={true}
              variant="outlined"
              size="small"
            />
          );
        },
      },
        {
        accessorKey: "new_product_quantity",
        header: "Current Import Quantity",
        size: 100,
        Cell: ({ cell }) => {
          const productId = cell.row.original.id;
          const quantity = cell.getValue();
          const warehouseQuantity = cell.row.original?.quantity;

          const exceedsQuantity = quantity > warehouseQuantity;
          return (
            <div>
              <TextField
                type="text"
                min={0}
                className={
                  exceedsQuantity ||
                    (quantity === 0 &&
                      quantityError &&
                      cell.row.original?.product_selection === "warehouse")
                    ? "border border-red"
                    : cell.row.original?.product_selection === "warehouse"
                      ? "border-yellow"
                      : ""
                }
                value={quantity}
                disabled={
                  (!hasImportUpdatePermission &&
                    decodedToken?.roles?.some(
                      (role) => role.role_type !== roleTypes.SUPER_ADMIN
                    ) &&
                    cell.row.original?.product_selection !== "warehouse") ||
                  cell.row.original?.product_selection === null ||
                  (cell.row.original?.product_selection &&
                    cell.row.original?.product_selection !== "warehouse") ||
                  cell.row.original?.product_selection === null ||
                  !cell.row.original?.quantity
                }
                onChange={(e) => {
                  let value = e.target.value;

                  if (/^\d*$/.test(value) || value === "") {
                    handleProductQuantityChange(productId, Number(value), cell);
                  }
                }}
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    ...((exceedsQuantity ||
                      (quantity === 0 &&
                        quantityError &&
                        cell.row.original?.product_selection ===
                        "warehouse")) && {
                      "& fieldset": {
                        borderColor: "red",
                      },
                      "&:hover fieldset": {
                        borderColor: "red",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "red",
                      },
                    }),
                  },
                }}
              />
              {(exceedsQuantity ||
                (quantity === 0 &&
                  quantityError &&
                  cell.row.original?.product_selection === "warehouse")) && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {quantity > 0 &&
                      `Can't import quantity more than ${warehouseQuantity} quantity`}
                    {quantity === 0 && "Import quantity must be greater than 0"}
                  </span>
                )}
            </div>
          );
        },
      },
      { accessorKey: "manufacturer", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      {
        accessorKey: "warehouse_aggregated_search_text",
        header: "Searchable Text",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: false,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      { accessorKey: "description", header: "Description", size: 150 },

      { accessorKey: "sku", header: "SKU", size: 150 },
          {
        accessorKey: "warehouse_jobs",
        header: "Jobs",
        size: 150,
        Cell: ({ row }) => {
          const jobs = row.original.warehouse_jobs;

          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
              }}
              className="hide-scrollbar"
            >
              <span>{jobs || "-"}</span>
            </div>
          );
        },
      },

      {
        accessorKey: "warehouse_systems",
        header: "Systems",
        size: 150,
        Cell: ({ row }) => {
          const systems = row.original.warehouse_systems;

          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
              }}
              className="hide-scrollbar"
            >
              <span>{systems || "-"}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "warehouse_phases",
        header: "Phases",
        size: 150,
        Cell: ({ row }) => {
          const phases = row.original.warehouse_phases;

          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
              }}
              className="hide-scrollbar"
            >
              <span>{phases || "-"}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "product_min_quantity_notify",
        header: "Min Quantity Notify",
        size: 150,
        Cell: ({ cell }) => {
          const [isFocused, setIsFocused] = React.useState(false);
          const [isTouched, setIsTouched] = React.useState(false);
          const productId = cell.row.original.id;
          const product_min_quantity_notify = cell.getValue();
          const isOldProduct = oldWarehouseProducts?.some(
            (oldProd) => oldProd.id === cell.row.original?.id
          );

          const originalValue = oldWarehouseProducts?.find(
            (oldProd) => oldProd.id === cell.row.original?.id
          )?.product_min_quantity_notify;

          const hasChanged = isOldProduct
            ? originalValue !== product_min_quantity_notify
            : cell.row.original?.product_min_quantity_notify_changed === true;

          const currentValue = Number(product_min_quantity_notify);
          const isZero = currentValue === 0;
          const isInvalid = isZero;
          const showRedBorder = isInvalid && isTouched && !isFocused;
          const showYellowBorder =
            !showRedBorder &&
            ((!isOldProduct && isTouched) || (hasChanged && !isZero));

          return (
            <>
              <TextField
                type="text"
                min={0}
                className={
                  showYellowBorder
                    ? "border-yellow"
                    : showRedBorder || (minQuantityError && isZero)
                      ? "border-red"
                      : cell.row.original?.product_selection === "warehouse"
                        ? "border-yellow"
                        : ""
                }
                disabled={
                  !hasImportUpdatePermission &&
                  decodedToken?.roles?.some(
                    (role) => role.role_type !== roleTypes.SUPER_ADMIN
                  )
                }
                value={product_min_quantity_notify}
                onFocus={() => setIsFocused(true)}
                onBlur={() => {
                  setIsFocused(false);
                  setIsTouched(true);
                }}
                onChange={(e) => {
                  let value = e.target.value;
                  if (/^\d*$/.test(value) || value === "") {
                    handleProductMinQuantityNotifyChange(
                      productId,
                      Number(value),
                      cell
                    );
                  }
                }}
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    ...(showRedBorder && {
                      "& fieldset": {
                        borderColor: "red",
                      },
                      "&:hover fieldset": {
                        borderColor: "red",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "red",
                      },
                    }),
                  },
                }}
              />
              {(showRedBorder || (minQuantityError && isZero)) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Minimum quantity notify must be greater than 0
                </span>
              )}
            </>
          );
        },
      },
      {
        header: "Items",
        size: 150,
        Cell: ({ cell }) => {
          const hasWarehouseProductId =
            !!cell.row.original.warehouse_product_id;
          const message =
            "For the new incoming products the items are automatically created after product import is completed";

          const renderTooltip = (props) => (
            <ReactTooltip id={`tooltip-${cell.row.original.id}`} {...props}>
              {message}
            </ReactTooltip>
          );

          const viewItemsContent = (
            <span
              style={{
                cursor: hasWarehouseProductId ? "pointer" : "not-allowed",
                color: "blue",
                display: "flex",
                alignItems: "center",
                textDecoration: hasWarehouseProductId ? "underline" : "none",
              }}
              onClick={async () => {
                if (!hasWarehouseProductId) return;

                const isQuantityZero = await checkImportProductQuantity(
                  cell.row.original.id
                );

                if (isQuantityZero) {
                  setSelectedItemProduct(cell.row.original);
                  handleItemsClick(cell.row.original);
                } else {
                  handleUnsaveShow();
                }
              }}
            >
              View Items
            </span>
          );

          return hasWarehouseProductId ? (
            viewItemsContent
          ) : (
            <OverlayTrigger placement="top" overlay={renderTooltip}>
              {viewItemsContent}
            </OverlayTrigger>
          );
        },
      },
      {
        accessorKey: "rack_name",
        header: "Bin",
        size: 200,
        Cell: ({ cell }) => {
          const rackName = cell.getValue();
          const rowData = cell.row.original;
          const displayRack = rackName
            ? rackName +
            " - " +
            rowData.rack_number +
            " (R" +
            rowData.row_number +
            "C" +
            rowData.column_number +
            ")"
            : "No Bin Assigned";
          const product = cell.row.original;

          const isProductSameAsOld = (newProd) => {
            const oldProduct = oldWarehouseProducts?.find(
              (oldProd) => oldProd.id === newProd.id
            );

            return (
              oldProduct &&
              !oldProduct.product_selection &&
              (!newProd.product_selection ||
                newProd?.product_selection === "own") &&
              oldProduct.new_product_quantity ===
              newProd.new_product_quantity &&
              oldProduct.product_min_quantity_notify ===
              newProd.product_min_quantity_notify &&
              oldProduct.default_bin_id === newProd.default_bin_id
            );
          };

          const isProductSameAsWarehouse = (newProd) => {
            const oldProduct = warehouseProducts?.find(
              (oldProd) => oldProd.id === newProd.id
            );

            return (
              oldProduct &&
              oldProduct.product_selection === "warehouse" &&
              oldProduct.warehouse_id
            );
          };

          const status = isProductSameAsOld(product)
            ? ""
            : product.product_selection === "receiving"
              ? "Receiving"
              : isProductSameAsWarehouse(product)
                ? `Warehouse`
                : "Updated";

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                margin: "0px",
              }}
              className={`${status && binError && !product.default_bin_id
                ? "text-danger"
                : ""
                }`}
            >
              <span
                style={{
                  fontStyle: !rackName ? "italic" : "normal",
                  color: !rackName ? "#999" : "#000",
                }}
                className={`${status && binError && !product.default_bin_id
                  ? "text-danger"
                  : status && !product.warehouse_product_id
                    ? "text-yellow"
                    : ""
                  }`}
              >
                {displayRack}
              </span>
              {(hasAssignBinLocationPermission ||
                !product.warehouse_product_id ||
                decodedToken?.roles?.some(
                  (role) => role.role_type === roleTypes.SUPER_ADMIN
                )) && (
                  <Tooltip
                    title={
                      !hasAssignBinLocationPermission &&
                        !product.warehouse_product_id &&
                        !decodedToken?.roles?.some(
                          (role) => role.role_type === roleTypes.SUPER_ADMIN
                        )
                        ? "Edit Bin"
                        : ""
                    }
                  >
                    <IconButton
                      size="small"
                      disabled={
                        product.warehouse_product_id &&
                        !hasAssignBinLocationPermission &&
                        decodedToken?.roles?.some(
                          (role) => role.role_type !== roleTypes.SUPER_ADMIN
                        )
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedRackProduct(rowData);
                        setOpenRackModal(true);
                      }}
                    >
                      <EditIcon
                        className={`${status && binError && !product.default_bin_id
                          ? "text-danger"
                          : status && !product.warehouse_product_id
                            ? "text-yellow"
                            : ""
                          }`}
                        fontSize="small"
                      />
                    </IconButton>
                  </Tooltip>
                )}
            </div>
          );
        },
      },

      {
        accessorKey: "status",
        header: "Imported from",
        size: 150,
        Cell: ({ cell }) => {
          const product = cell.row.original;

          const isProductSameAsOld = (newProd) => {
            const oldProduct = oldWarehouseProducts?.find(
              (oldProd) => oldProd.id === newProd.id
            );

            return (
              oldProduct &&
              !oldProduct.product_selection &&
              (!newProd.product_selection ||
                newProd?.product_selection === "own") &&
              oldProduct.new_product_quantity ===
              newProd.new_product_quantity &&
              oldProduct.product_min_quantity_notify ===
              newProd.product_min_quantity_notify &&
              oldProduct.default_bin_id === newProd.default_bin_id
            );
          };

          const isProductSameAsWarehouse = (newProd) => {
            const oldProduct = warehouseProducts?.find(
              (oldProd) => oldProd.id === newProd.id
            );

            return (
              oldProduct &&
              oldProduct.product_selection === "warehouse" &&
              oldProduct.warehouse_id
            );
          };

          const status = isProductSameAsOld(product)
            ? "-"
            : product.product_selection === "receiving"
              ? "Receiving"
              : isProductSameAsWarehouse(product)
                ? `Warehouse`
                : "-";

          return (
            <span className={`status-${status.toLowerCase()}`}>
              {status === "Warehouse"
                ? `Warehouse - ${warehouses.find((wh) => wh.id === product.warehouse_id)
                  ?.name || "Unknown"
                }`
                : status}
            </span>
          );
        },
      },
      {
        header: "Actions",
        size: 120,
        Cell: ({ cell }) => {
          const product = cell.row.original;

          const isProductSameAsWarehouse = (newProd) => {
            const oldProduct = warehouseProducts?.find(
              (oldProd) => oldProd.id === newProd.id
            );

            return (
              oldProduct &&
              oldProduct.product_selection === "warehouse" &&
              oldProduct.warehouse_id
            );
          };

          const status = isProductSameAsWarehouse(product);

          return (
            <div style={{ display: "flex", gap: "8px" }}>
              {status ? (
                <Tooltip title="Cancel Imported Product">
                  <IconButton
                    size="medium"
                    color="error"
                    onClick={() => handleCancelImportProduct(product)}
                  >
                    <CancelIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    [
      warehouseProducts,
      selectedProductRows,
      handleProductMinQuantityNotifyChange,
      handleProductQuantityChange,
      selectedItemProduct,
    ]
  );

  const handleHistoryClick = (historyData) => {
    setSelectedHistory(historyData);
    setShowHistoryView(true);
  };

  const status = [
    { value: "active", label: "Active" },
    { value: "in-active", label: "Inactive" },
    { value: "damaged", label: "Damaged" },
    { value: "repaired", label: "Repaired" },
  ];

  const [jobSystemsPhasesMap, setJobSystemsPhasesMap] = useState({});

  const fetchJobSystemsPhases = async (jobIds) => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return [];
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.post(
        `${url.backendURL}warehouse/jobs/active/system-phases`,
        { jobIds },
        config
      );
      return response.data.response.data;
    } catch (error) {
      if (alertRefProduct.current) {
        alertRefProduct.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(error, "products");
      return [];
    }
  };

  useEffect(() => {
    const loadInitialJobsData = async () => {
      if (productItems && productItems.length > 0) {
        const uniqueJobIds = [
          ...new Set(productItems.map((item) => item.jobId).filter(Boolean)),
        ];

        if (uniqueJobIds.length > 0) {
          const data = await fetchJobSystemsPhases(uniqueJobIds);
          const newMap = {};
          data.forEach((jobData) => {
            newMap[jobData.job_id] = jobData;
          });
          setJobSystemsPhasesMap((prev) => ({ ...prev, ...newMap }));
        }
      }
    };
    loadInitialJobsData();
  }, [productItems]);

  const [focusedCells, setFocusedCells] = useState({});

  const addYellowFocus = (rowId, columnId) => {
    const key = `${rowId}-${columnId}`;
    setFocusedCells((prev) => ({ ...prev, [key]: true }));

    setTimeout(() => {
      setFocusedCells((prev) => {
        const newState = { ...prev };
        delete newState[key];
        return newState;
      });
    }, 3000);
  };

  const warehouseProductItemsColumns = useMemo(
    () => [
      { accessorKey: "id", header: "ID", size: 100, enableEditing: false },
      {
        accessorKey: "po_number",
        header: "PO Number",
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: "notes",
        header: "Notes",
        size: 180,
        enableEditing: false,
        Cell: ({ cell, row, table }) => {
          const [isEditingNote, setIsEditingNote] = useState(false);
          const [noteValue, setNoteValue] = useState(cell.getValue() || "");
          const [isSubmittingNotes, setIsSubmittingNotes] = useState(false);
          const [successNotesLoader, setSuccessNotesLoader] = useState(false);
          const [errorNotesLoader, setErrorNotesLoader] = useState(false);
          const inputRef = useRef(null);
          const [itemProduct, setItemProduct] = useState(selectedItemProduct);

          useEffect(() => {
            if (isEditingNote && inputRef.current) {
              inputRef.current.focus();
              inputRef.current.select();
            }
          }, [isEditingNote]);

          const handleBlur = () => {
            setIsEditingNote(false);
            const trimmedValue = noteValue.trim();

            if (trimmedValue !== (cell.getValue() || "").trim()) {
              submitNotes(
                trimmedValue,
                cell.row.original.id,
                setIsSubmittingNotes,
                setSuccessNotesLoader,
                setNoteValue,
                setErrorNotesLoader,
                isSubmittingNotes,
                cell,
                itemProduct
              );

              setProductItems((prevItems) =>
                prevItems.map((item) =>
                  item.id === cell.row.original.id
                    ? { ...item, notes: trimmedValue }
                    : item
                )
              );
            }
          };

          return (
            <div style={{ position: "relative", width: "100%" }}>
              <textarea
                ref={inputRef}
                value={noteValue}
                onChange={(e) => setNoteValue(e.target.value)}
                onBlur={handleBlur}
                disabled={
                  (!hasImportUpdatePermission &&
                    decodedToken?.roles?.some(
                      (role) => role.role_type !== roleTypes.SUPER_ADMIN
                    )) ||
                  isSubmittingNotes
                }
                style={{
                  width: "100%",
                  padding: "4px 8px",
                  border: successNotesLoader
                    ? "2px solid #198754"
                    : errorNotesLoader
                      ? "2px solid #d91111ff"
                      : "2px solid #3b82f6",
                  borderRadius: "4px",
                  fontSize: "13px",
                  outline: "none",
                  backgroundColor: isSubmittingNotes ? "#f3f4f6" : "#ffffff",
                  cursor: isSubmittingNotes ? "wait" : "text",
                  resize: "vertical",
                  minHeight: "60px",
                }}
                placeholder="Enter notes..."
              />

              {isSubmittingNotes && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <RotatingLines
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                    strokeColor="#b2b4b9"
                    color="#b2b4b9"
                    visible={true}
                  />
                </div>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "history",
        header: "History",
        size: 180,
        enableEditing: false,
        Cell: ({ cell }) => {
          const history = cell.getValue();
          const firstHistory =
            Array.isArray(history) && history.length > 0 ? history[0] : null;

          if (!firstHistory) {
            return (
              <span
                style={{
                  fontStyle: "italic",
                  color: "#9ca3af",
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                  height: "32px",
                }}
              >
                No History
              </span>
            );
          }

          const getStatusColor = (status) => {
            switch (status?.toLowerCase()) {
              case "active":
                return "#10b981";
              case "pending":
                return "#f59e0b";
              case "completed":
                return "#3b82f6";
              default:
                return "#6b7280";
            }
          };

          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <div
                onClick={() => handleHistoryClick(history)}
                style={{
                  fontSize: "11px",
                  padding: "6px 8px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "3px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#111827",
                      textTransform: "capitalize",
                    }}
                  >
                    {firstHistory.type}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {firstHistory.notes && (
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          backgroundColor: "#f59e0b",
                          borderRadius: "50%",
                          display: "inline-block",
                        }}
                        title="Has Notes"
                      ></span>
                    )}
                    <span
                      style={{
                        fontSize: "9px",
                        padding: "2px 6px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        backgroundColor:
                          getStatusColor(firstHistory.status) + "20",
                        color: getStatusColor(firstHistory.status),
                        fontWeight: "500",
                      }}
                    >
                      {firstHistory.status}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    color: "#4b5563",
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    marginBottom: "2px",
                  }}
                >
                  <span style={{ fontWeight: "500" }}>
                    {firstHistory.type === "order" && "PO# "}
                    {firstHistory.received_from && firstHistory.received_from}
                  </span>
                  {firstHistory.received_from && (
                    <span style={{ color: "#9ca3af" }}>→</span>
                  )}
                  <span>
                    {firstHistory.received_to && firstHistory.received_to}
                  </span>
                </div>

                <div
                  className="bg-none"
                  style={{
                    color: "#9ca3af",
                    fontSize: "9px",
                    fontWeight: "400",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    {new Date(firstHistory.date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "2-digit",
                    })}
                  </span>
                  <span className="text-primary fw-bold">Click to view</span>
                </div>
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "phase_name",
        header: "Phase Name",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: true,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      {
        accessorKey: "job_name",
        header: "Job Name",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: true,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      {
        accessorKey: "system_name",
        header: "System Name",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: true,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      {
        accessorKey: "jobId",
        header: "Job",
        editVariant: "select",
        size: 150,

        editSelectOptions: [
          { label: "Unassign Job", value: "unassign" },
          ...activeJobs.map((job) => ({
            label: job.name,
            value: job.id,
          })),
        ],

        muiEditTextFieldProps: ({ cell, row, table }) => {
          const [isSubmittingJob, setIsSubmittingJob] = useState(false);
          const [successJobLoader, setSuccessJobLoader] = useState(false);
          const [errorJobLoader, setErrorJobLoader] = useState(false);
          const [errorMessage, setErrorMessage] = useState("");
          const currentValue = cell.getValue();
          const selectRef = useRef(null);
          const isFocused = focusedCells[`${row.original.id}-jobId`];

          const submitJobSystemPhase = async (
            newJobId,
            systemId,
            phaseId,
            itemId
          ) => {
            if (isSubmittingJob) return;

            try {
              setSuccessJobLoader(false);
              setErrorJobLoader(false);
              setIsSubmittingJob(true);
              setErrorMessage("");

              const config = { headers: { Authorization: `${token}` } };
              const data = {
                jobId: newJobId,
                systemId: systemId,
                phaseId: phaseId,
              };

              await axios.put(
                `${url.backendURL}warehouse/${id}/product/${selectedItemProduct.id}/item/${itemId}/job`,
                data,
                config
              );

              await getProductItems(selectedItemProduct, true);
              setIsSubmittingJob(false);
              setSuccessJobLoader(true);
              setErrorJobLoader(false);
              setAlerts({
                show: true,
                message: "Job updated successfully",
                type: "success",
                alertFor: "product-items",
              });
              setTimeout(() => {
                setSuccessJobLoader(false);
                setAlerts({ show: false, message: "", type: "", alertFor: "" });
              }, 3000);
              return true;
            } catch (err) {
              if (alertRefProduct.current) {
                alertRefProduct.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
              handleError(err, "products");
              setErrorJobLoader(true);
              setSuccessJobLoader(false);

              let errorMsg = "Failed to update";
              if (err.response?.status === 401) {
                errorMsg = "Unauthorized access";
              } else if (err.response?.status === 404) {
                errorMsg = "Item not found";
              } else if (err.response?.status === 500) {
                errorMsg = "Server error occurred";
              } else if (err.response?.data?.message) {
                errorMsg = err.response.data.message;
              } else if (err.message) {
                errorMsg = err.message;
              }

              setErrorMessage(errorMsg);
              setIsSubmittingJob(false);
              setTimeout(() => setErrorMessage(""), 5000);
              return false;
            }
          };

          const handleJobChange = async (newJobId) => {
            if ((!newJobId || newJobId === "unassign") && !currentValue) return;
            if (newJobId === currentValue) return;

            if (!newJobId || newJobId === "unassign") {
              if (row.original.status === "installed") {
                setErrorMessage(
                  "Job cannot be unassigned if the product is installed."
                );
                setErrorJobLoader(true);
                setTimeout(() => setErrorJobLoader(false), 3000);
                return;
              }

              setProductItems((prev) =>
                prev.map((item) =>
                  item.id === row.original.id
                    ? {
                      ...item,
                      jobId: null,
                      systemId: null,
                      system_name: null,
                      phaseId: null,
                      phase_name: null,
                    }
                    : item
                )
              );

              await submitJobSystemPhase(null, null, null, row.original.id);
              return;
            }

            let jobData = jobSystemsPhasesMap[newJobId];

            if (!jobData) {
              const data = await fetchJobSystemsPhases([newJobId]);
              if (data && data.length > 0) {
                jobData = data[0];
                setJobSystemsPhasesMap((prev) => ({
                  ...prev,
                  [newJobId]: jobData,
                }));
              }
            }

            const currentItem = row.original;
            let newSystemId = null;
            let newSystemName = null;
            let newPhaseId = null;
            let newPhaseName = null;
            let shouldFocusSystem = false;

            if (
              jobData &&
              jobData.systems_phases &&
              jobData.systems_phases.length > 0
            ) {
              const systemExists = jobData.systems_phases.some(
                (sp) => sp.system_id === currentItem.systemId
              );

              if (systemExists) {
                newSystemId = currentItem.systemId;
                newSystemName = currentItem.system_name;

                const phaseExists = jobData.systems_phases.some(
                  (sp) =>
                    sp.system_id === currentItem.systemId &&
                    sp.phase_id === currentItem.phaseId
                );

                if (phaseExists) {
                  newPhaseId = currentItem.phaseId;
                  newPhaseName = currentItem.phase_name;
                } else {
                  const systemPhase = jobData.systems_phases.find(
                    (sp) => sp.system_id === currentItem.systemId
                  );

                  if (
                    jobData.active_system_id === currentItem.systemId &&
                    jobData.active_phase_id
                  ) {
                    newPhaseId = jobData.active_phase_id;
                    newPhaseName = jobData.active_phase_name;
                  } else {
                    newPhaseId = systemPhase?.phase_id || null;
                    newPhaseName = systemPhase?.phase_name || null;
                  }
                }
              } else {
                newSystemId = jobData.active_system_id || null;
                newSystemName = jobData.active_system_name || null;
                newPhaseId = jobData.active_phase_id || null;
                newPhaseName = jobData.active_phase_name || null;
                if (!newSystemId) {
                  shouldFocusSystem = true;
                }
              }
            } else {
              shouldFocusSystem = true;
            }

            setProductItems((prev) =>
              prev.map((item) =>
                item.id === row.original.id
                  ? {
                    ...item,
                    jobId: newJobId,
                    systemId: newSystemId,
                    system_name: newSystemName,
                    phaseId: newPhaseId,
                    phase_name: newPhaseName,
                  }
                  : item
              )
            );

            if (shouldFocusSystem) {
              setTimeout(() => {
                table.setEditingCell({
                  rowIndex: row.index,
                  columnId: "systemId",
                });
              }, 100);
            }

            if (newJobId && newSystemId && newPhaseId) {
              const apiSuccess = await submitJobSystemPhase(
                newJobId,
                newSystemId,
                newPhaseId,
                row.original.id
              );
              if (apiSuccess) {
                addYellowFocus(row.original.id, "systemId");
                if (newPhaseId) {
                  addYellowFocus(row.original.id, "phaseId");
                }
              }
            } else {
              addYellowFocus(row.original.id, "systemId");
              if (newPhaseId) {
                addYellowFocus(row.original.id, "phaseId");
              }
            }
          };
          return {
            select: true,
            value: currentValue ?? "",
            disabled:
              isSubmittingJob ||
              (!hasImportUpdatePermission &&
                decodedToken?.roles?.some(
                  (role) => role.role_type !== roleTypes.SUPER_ADMIN
                )),
            error: errorJobLoader,
            helperText: errorMessage,
            displayEmpty: true,
            onChange: async (event) => {
              const newJobId = event.target.value || null;
              await handleJobChange(newJobId);
            },
            sx: {
              minWidth: "150px",
              maxWidth: "150px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                "&.Mui-error fieldset": {
                  border: "none",
                },
              },
              backgroundColor: "none",
              "& .MuiSelect-select": {
                padding: "8px 12px",
                fontSize: "14px",
                color: errorJobLoader
                  ? "#dc2626"
                  : successJobLoader
                    ? "#059669"
                    : isFocused
                      ? "#eab308"
                      : currentValue
                        ? "#374151"
                        : "#9ca3af",
                backgroundColor: "none",
              },
              "& .MuiSelect-select.Mui-focused": {
                color: "#eab308 !important",
              },
              "& .MuiSelect-icon": {
                color: errorJobLoader
                  ? "#ef4444 !important"
                  : successJobLoader
                    ? "#10b981 !important"
                    : isFocused
                      ? "#eab308 !important"
                      : "#6b7280 !important",
                transition: "color 0.2s ease-in-out",
              },
              "& .MuiFormHelperText-root": {
                color: errorJobLoader
                  ? "#dc2626"
                  : successJobLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                marginLeft: "12px",
                fontWeight: errorJobLoader || successJobLoader ? "500" : "400",
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "&.Mui-error .MuiFormHelperText-root": {
                color: "#dc2626 !important",
              },
            },
            style: {
              position: "relative",
            },
            SelectProps: {
              displayEmpty: true,
              renderValue: (selected) => {
                if (!selected || selected === "unassign") {
                  return (
                    <span style={{ color: "#9ca3af" }}>No Job Assigned</span>
                  );
                }
                const job = activeJobs.find((j) => j.id === selected);
                return job?.name || "Job Unassigned";
              },
            },
            InputProps: {
              style: {
                position: "relative",
              },
              endAdornment: isSubmittingJob ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "0%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <RotatingLines
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                    strokeColor="#b2b4b9"
                    color="#b2b4b9"
                    visible={true}
                  />
                </div>
              ) : null,
            },
            FormHelperTextProps: {
              sx: {
                color: errorJobLoader
                  ? "#dc2626"
                  : successJobLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                fontWeight: errorJobLoader || successJobLoader ? "500" : "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            },
          };
        },

        Cell: ({ cell }) => {
          const jobId = cell.getValue();
          const job = activeJobs.find((j) => j.id === jobId);
          return (
            <span
              style={{
                display: "inline-block",
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: job ? "#374151" : "#9ca3af",
              }}
              title={job?.name || "No Job Assigned"}
            >
              {job ? job.name : "No Job Assigned"}
            </span>
          );
        },
      },
      {
        accessorKey: "systemId",
        header: "System",
        editVariant: "select",
        size: 150,

        editSelectOptions: ({ row }) => {
          const currentJobId = row.original.jobId;

          if (!currentJobId) {
            return [];
          }

          const jobData = jobSystemsPhasesMap[currentJobId];
          const systemsMap = new Map();

          if (
            jobData &&
            jobData.systems_phases &&
            jobData.systems_phases.length > 0
          ) {
            jobData.systems_phases.forEach((sp) => {
              if (!systemsMap.has(sp.system_id)) {
                systemsMap.set(sp.system_id, {
                  value: sp.system_id,
                  label: sp.system_name,
                });
              }
            });
          }

          return Array.from(systemsMap.values());
        },

        muiEditTextFieldProps: ({ cell, row, table }) => {
          const [isSubmittingSystem, setIsSubmittingSystem] = useState(false);
          const [successSystemLoader, setSuccessSystemLoader] = useState(false);
          const [errorSystemLoader, setErrorSystemLoader] = useState(false);
          const [errorMessage, setErrorMessage] = useState("");
          const currentValue = cell.getValue();
          const currentJobId = row.original.jobId;
          const isFocused = focusedCells[`${row.original.id}-systemId`];

          const jobData = jobSystemsPhasesMap[currentJobId];
          const systemsMap = new Map();
          if (
            jobData &&
            jobData.systems_phases &&
            jobData.systems_phases.length > 0
          ) {
            jobData.systems_phases.forEach((sp) => {
              if (!systemsMap.has(sp.system_id)) {
                systemsMap.set(sp.system_id, {
                  value: sp.system_id,
                  label: sp.system_name,
                });
              }
            });
          }

          const systemOptions = Array.from(systemsMap.values());

          const submitJobSystemPhase = async (
            jobId,
            systemId,
            phaseId,
            itemId
          ) => {
            if (isSubmittingSystem) return;
            if (!phaseId) {
              setErrorMessage("Please select a phase before saving");
              setErrorSystemLoader(true);
              setTimeout(() => {
                setErrorMessage("");
                setErrorSystemLoader(false);
              }, 3000);
              return false;
            }

            try {
              setSuccessSystemLoader(false);
              setErrorSystemLoader(false);
              setIsSubmittingSystem(true);
              setErrorMessage("");

              const config = { headers: { Authorization: `${token}` } };
              const data = {
                jobId: jobId,
                systemId: systemId,
                phaseId: phaseId,
              };

              await axios.put(
                `${url.backendURL}warehouse/${id}/product/${selectedItemProduct.id}/item/${itemId}/job`,
                data,
                config
              );

              setIsSubmittingSystem(false);
              setSuccessSystemLoader(true);
              setErrorSystemLoader(false);
              setAlerts({
                show: true,
                message: "Job updated successfully",
                type: "success",
                alertFor: "product-items",
              });
              setTimeout(() => {
                setSuccessSystemLoader(false);
                setAlerts({ show: false, message: "", type: "", alertFor: "" });
              }, 3000);
              return true;
            } catch (err) {
              if (alertRefProduct.current) {
                alertRefProduct.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
              handleError(err, "products");
              setErrorSystemLoader(true);
              setSuccessSystemLoader(false);

              let errorMsg = "Failed to update";
              if (err.response?.data?.message) {
                errorMsg = err.response.data.message;
              }

              setErrorMessage(errorMsg);
              setIsSubmittingSystem(false);
              setTimeout(() => setErrorMessage(""), 5000);
              return false;
            }
          };

          const handleSystemChange = async (newSystemId) => {
            if (!currentJobId || newSystemId === currentValue) return;

            const jobData = jobSystemsPhasesMap[currentJobId];

            if (
              !jobData ||
              !jobData.systems_phases ||
              jobData.systems_phases.length === 0
            ) {
              return;
            }

            let newPhaseId = null;
            let newPhaseName = null;
            let shouldFocusPhase = false;

            if (newSystemId) {
              const currentPhaseId = row.original.phaseId;

              const phaseExists = jobData.systems_phases.some(
                (sp) =>
                  sp.system_id === newSystemId && sp.phase_id === currentPhaseId
              );

              if (phaseExists) {
                newPhaseId = currentPhaseId;
                newPhaseName = row.original.phase_name;
              } else {
                if (newSystemId === jobData.active_system_id) {
                  newPhaseId = jobData.active_phase_id || null;
                  newPhaseName = jobData.active_phase_name || null;
                } else {
                  const systemPhase = jobData.systems_phases.find(
                    (sp) => sp.system_id === newSystemId
                  );
                  newPhaseId = systemPhase?.phase_id || null;
                  newPhaseName = systemPhase?.phase_name || null;
                }
                if (!newPhaseId) {
                  shouldFocusPhase = true;
                }
              }
            }

            const selectedSystem = systemOptions.find(
              (s) => s.value === newSystemId
            );

            setProductItems((prev) =>
              prev.map((item) =>
                item.id === row.original.id
                  ? {
                    ...item,
                    systemId: newSystemId,
                    system_name: selectedSystem?.label || null,
                    phaseId: newPhaseId,
                    phase_name: newPhaseName,
                  }
                  : item
              )
            );

            if (shouldFocusPhase) {
              setTimeout(() => {
                table.setEditingCell({
                  rowIndex: row.index,
                  columnId: "phaseId",
                });
              }, 100);
            }

            if (currentJobId && newSystemId && newPhaseId) {
              const apiSuccess = await submitJobSystemPhase(
                currentJobId,
                newSystemId,
                newPhaseId,
                row.original.id
              );

              if (apiSuccess) {
                addYellowFocus(row.original.id, "phaseId");
              }
            } else {
              addYellowFocus(row.original.id, "phaseId");
            }
          };

          return {
            select: true,
            value: currentValue ?? "",
            disabled:
              !currentJobId ||
              isSubmittingSystem ||
              (!hasImportUpdatePermission &&
                decodedToken?.roles?.some(
                  (role) => role.role_type !== roleTypes.SUPER_ADMIN
                )),
            error: errorSystemLoader,
            helperText: errorMessage,
            displayEmpty: true,
            onChange: async (event) => {
              const newSystemId = event.target.value || null;
              await handleSystemChange(newSystemId);
            },
            sx: {
              minWidth: "150px",
              maxWidth: "150px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                "&.Mui-error fieldset": {
                  border: "none",
                },
              },
              backgroundColor: "none",
              "& .MuiSelect-select": {
                padding: "8px 12px",
                fontSize: "14px",
                color: errorSystemLoader
                  ? "#dc2626"
                  : successSystemLoader
                    ? "#059669"
                    : isFocused
                      ? "#eab308 !important"
                      : currentValue
                        ? "#374151"
                        : "#9ca3af",
                backgroundColor: "none",
              },
              "& .MuiSelect-select.Mui-focused": {
                color: "#eab308 !important",
              },
              "& .MuiSelect-icon": {
                color: errorSystemLoader
                  ? "#ef4444 !important"
                  : successSystemLoader
                    ? "#10b981 !important"
                    : isFocused
                      ? "#eab308 !important"
                      : "#6b7280 !important",
                transition: "color 0.2s ease-in-out",
              },
              "& .MuiFormHelperText-root": {
                color: errorSystemLoader
                  ? "#dc2626"
                  : successSystemLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                marginLeft: "12px",
                fontWeight:
                  errorSystemLoader || successSystemLoader ? "500" : "400",
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "&.Mui-error .MuiFormHelperText-root": {
                color: "#dc2626 !important",
              },
            },
            style: {
              position: "relative",
            },
            SelectProps: {
              displayEmpty: true,
              renderValue: (selected) => {
                if (!currentJobId) {
                  return (
                    <span style={{ color: "#9ca3af" }}>
                      First select a job...
                    </span>
                  );
                }
                if (!selected) {
                  return (
                    <span
                      style={{
                        color: isFocused ? "#eab308" : "#9ca3af",
                      }}
                    >
                      {systemOptions.length === 0
                        ? "No System Assigned"
                        : "Select system..."}
                    </span>
                  );
                }
                const system = systemOptions.find((s) => s.value === selected);
                return system?.label || "No System Assigned";
              },
            },
            children:
              systemOptions.length === 0
                ? [
                  <MenuItem key="no-system" value="" disabled>
                    No system found
                  </MenuItem>,
                ]
                : undefined,
            InputProps: {
              style: {
                position: "relative",
              },
              endAdornment: isSubmittingSystem ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "0%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <RotatingLines
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                    strokeColor="#b2b4b9"
                    color="#b2b4b9"
                    visible={true}
                  />
                </div>
              ) : null,
            },
            FormHelperTextProps: {
              sx: {
                color: errorSystemLoader
                  ? "#dc2626"
                  : successSystemLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                fontWeight:
                  errorSystemLoader || successSystemLoader ? "500" : "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            },
          };
        },

        Cell: ({ cell, row }) => {
          const systemId = cell.getValue();
          const systemName = row.original.system_name;
          return (
            <span
              style={{
                display: "inline-block",
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: systemId ? "#374151" : "#9ca3af",
              }}
              title={systemName || "No System Assigned"}
            >
              {systemName || "No System Assigned"}
            </span>
          );
        },
      },
      {
        accessorKey: "phaseId",
        header: "Phase",
        editVariant: "select",
        size: 150,

        muiEditTextFieldProps: ({ cell, row, table }) => {
          const [isSubmittingPhase, setIsSubmittingPhase] = useState(false);
          const [successPhaseLoader, setSuccessPhaseLoader] = useState(false);
          const [errorPhaseLoader, setErrorPhaseLoader] = useState(false);
          const [errorMessage, setErrorMessage] = useState("");
          const currentValue = cell.getValue();
          const currentJobId = row.original.jobId;
          const currentSystemId = row.original.systemId;
          const isFocused = focusedCells[`${row.original.id}-phaseId`];

          const jobData = jobSystemsPhasesMap[currentJobId];
          const phaseOptions = [];

          if (
            jobData &&
            jobData.systems_phases &&
            jobData.systems_phases.length > 0 &&
            currentSystemId
          ) {
            jobData.systems_phases
              .filter((sp) => sp.system_id === currentSystemId)
              .forEach((sp) => {
                phaseOptions.push({
                  value: sp.phase_id,
                  label: sp.phase_name,
                });
              });
          }

          const submitJobSystemPhase = async (
            jobId,
            systemId,
            phaseId,
            itemId
          ) => {
            if (isSubmittingPhase) return;
            if (!phaseId) {
              setErrorMessage("Please select a phase");
              setErrorPhaseLoader(true);
              setTimeout(() => {
                setErrorMessage("");
                setErrorPhaseLoader(false);
              }, 3000);
              return false;
            }

            try {
              setSuccessPhaseLoader(false);
              setErrorPhaseLoader(false);
              setIsSubmittingPhase(true);
              setErrorMessage("");

              const config = { headers: { Authorization: `${token}` } };
              const data = {
                jobId: jobId,
                systemId: systemId,
                phaseId: phaseId,
              };

              await axios.put(
                `${url.backendURL}warehouse/${id}/product/${selectedItemProduct.id}/item/${itemId}/job`,
                data,
                config
              );

              setIsSubmittingPhase(false);
              setSuccessPhaseLoader(true);
              setErrorPhaseLoader(false);
              setAlerts({
                show: true,
                message: "Job updated successfully",
                type: "success",
                alertFor: "product-items",
              });
              setTimeout(() => {
                setSuccessPhaseLoader(false);
                setAlerts({ show: false, message: "", type: "", alertFor: "" });
              }, 3000);
              return true;
            } catch (err) {
              if (alertRefProduct.current) {
                alertRefProduct.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
              handleError(err, "products");
              setErrorPhaseLoader(true);
              setSuccessPhaseLoader(false);

              let errorMsg = "Failed to update";
              if (err.response?.data?.message) {
                errorMsg = err.response.data.message;
              }

              setErrorMessage(errorMsg);
              setIsSubmittingPhase(false);
              setTimeout(() => setErrorMessage(""), 5000);
              return false;
            }
          };

          const handlePhaseChange = async (newPhaseId) => {
            if (!currentJobId || !currentSystemId || newPhaseId === currentValue) return;

            const selectedPhase = phaseOptions.find(
              (p) => p.value === newPhaseId
            );

            setProductItems((prev) =>
              prev.map((item) =>
                item.id === row.original.id
                  ? {
                    ...item,
                    phaseId: newPhaseId,
                    phase_name: selectedPhase?.label || null,
                  }
                  : item
              )
            );

            if (newPhaseId) {
              await submitJobSystemPhase(
                currentJobId,
                currentSystemId,
                newPhaseId,
                row.original.id
              );
            }
          };

          return {
            select: true,
            value: currentValue ?? "",
            disabled:
              !currentSystemId ||
              isSubmittingPhase ||
              (!hasImportUpdatePermission &&
                decodedToken?.roles?.some(
                  (role) => role.role_type !== roleTypes.SUPER_ADMIN
                )),
            error: errorPhaseLoader,
            helperText: errorMessage,
            displayEmpty: true,
            onChange: async (event) => {
              const newPhaseId = event.target.value || null;
              await handlePhaseChange(newPhaseId);
            },
            sx: {
              minWidth: "150px",
              maxWidth: "150px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                "&.Mui-error fieldset": {
                  border: "none",
                },
              },
              backgroundColor: "none",
              "& .MuiSelect-select": {
                padding: "8px 12px",
                fontSize: "14px",
                color: errorPhaseLoader
                  ? "#dc2626 !important"
                  : successPhaseLoader
                    ? "#059669 !important"
                    : isFocused
                      ? "#eab308 !important"
                      : currentValue
                        ? "#374151"
                        : "#9ca3af",
                backgroundColor: "none",
              },
              "& .MuiSelect-select.Mui-focused": {
                color: errorPhaseLoader
                  ? "#dc2626 !important"
                  : successPhaseLoader
                    ? "#059669 !important"
                    : "#eab308 !important",
              },
              "& .MuiSelect-icon": {
                color: errorPhaseLoader
                  ? "#ef4444 !important"
                  : successPhaseLoader
                    ? "#10b981 !important"
                    : isFocused
                      ? "#eab308 !important"
                      : "#6b7280 !important",
                transition: "color 0.2s ease-in-out",
              },
              "& .MuiFormHelperText-root": {
                color: errorPhaseLoader
                  ? "#dc2626"
                  : successPhaseLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                marginLeft: "12px",
                fontWeight:
                  errorPhaseLoader || successPhaseLoader ? "500" : "400",
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "&.Mui-error .MuiFormHelperText-root": {
                color: "#dc2626 !important",
              },
            },
            style: {
              position: "relative",
            },
            SelectProps: {
              displayEmpty: true,
              renderValue: (selected) => {
                if (!currentJobId) {
                  return (
                    <span style={{ color: "#9ca3af" }}>
                      First select a job...
                    </span>
                  );
                }
                if (!currentSystemId) {
                  return (
                    <span style={{ color: "#9ca3af" }}>
                      First select a system
                    </span>
                  );
                }
                if (!selected) {
                  return (
                    <span
                      style={{
                        color: isFocused ? "#eab308" : "#9ca3af",
                      }}
                    >
                      {phaseOptions.length === 0
                        ? "No Phase Assigned"
                        : "Select phase..."}
                    </span>
                  );
                }
                const phase = phaseOptions.find((p) => p.value === selected);
                return phase?.label || "No Phase Assigned";
              },
            },
            children:
              phaseOptions.length === 0
                ? [
                  <MenuItem key="no-phase" value="" disabled>
                    No phase found
                  </MenuItem>,
                ]
                : undefined,
            InputProps: {
              style: {
                position: "relative",
              },
              endAdornment: isSubmittingPhase ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "0%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <RotatingLines
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                    strokeColor="#b2b4b9"
                    color="#b2b4b9"
                    visible={true}
                  />
                </div>
              ) : null,
            },
            FormHelperTextProps: {
              sx: {
                color: errorPhaseLoader
                  ? "#dc2626"
                  : successPhaseLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                fontWeight:
                  errorPhaseLoader || successPhaseLoader ? "500" : "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            },
          };
        },
        editSelectOptions: ({ row }) => {
          const currentJobId = row.original.jobId;
          const currentSystemId = row.original.systemId;

          if (!currentJobId || !currentSystemId) {
            return [];
          }

          const jobData = jobSystemsPhasesMap[currentJobId];
          const phaseOptions = [];

          if (
            jobData &&
            jobData.systems_phases &&
            jobData.systems_phases.length > 0
          ) {
            jobData.systems_phases
              .filter((sp) => sp.system_id === currentSystemId)
              .forEach((sp) => {
                phaseOptions.push({
                  value: sp.phase_id,
                  label: sp.phase_name,
                });
              });
          }

          return phaseOptions;
        },
        Cell: ({ cell, row }) => {
          const phaseId = cell.getValue();
          const phaseName = row.original.phase_name;
          return (
            <span
              style={{
                display: "inline-block",
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: phaseId ? "#374151" : "#9ca3af",
              }}
              title={phaseName || "No Phase Assigned"}
            >
              {phaseName || "No Phase Assigned"}
            </span>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        editVariant: "select",
        size: 50,
        editSelectOptions: status,
        muiEditTextFieldProps: ({ cell, row, table }) => {
          const [itemProduct, setItemProduct] = useState(selectedItemProduct);
          const [isSubmittingStatus, setIsSubmittingStatus] = useState(false);
          const [successStatusLoader, setSuccessStatusLoader] = useState(false);
          const [errorStatusLoader, setErrorStatusLoader] = useState(false);
          const [errorMessage, setErrorMessage] = useState("");
          const [successMessage, setSuccessMessage] = useState("");
          const [statusValue, setStatusValue] = useState(cell.getValue());
          const currentValue = cell.getValue() || "";

          const submitStatus = async (newStatus, itemId, cell) => {
            if (isSubmittingStatus) return;
            setSuccessStatusLoader(false);
            setErrorStatusLoader(false);
            try {
              setIsSubmittingStatus(true);
              setErrorMessage("");
              setSuccessMessage("");

              const config = {
                headers: {
                  Authorization: `${token}`,
                },
              };

              const data = {
                status: newStatus,
              };

              const response = await axios.put(
                `${url.backendURL}warehouse/${id}/products/${itemProduct.id}/item/${itemId}/status`,
                data,
                config
              );
              await getProductItems(itemProduct, true);
              setIsSubmittingStatus(false);
              setSuccessStatusLoader(true);
              setSuccessMessage("Status updated successfully");

              setErrorStatusLoader(false);
              setTimeout(() => {
                setSuccessStatusLoader(false);
                setSuccessMessage("");
              }, 3000);
            } catch (err) {
              if (alertRefProduct.current) {
                alertRefProduct.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
              handleError(err, "products");
              setSuccessStatusLoader(false);

              let errorMsg = "Failed to update status";
              if (err.response?.status === 401) {
                errorMsg = "Unauthorized access";
              } else if (err.response?.status === 404) {
                errorMsg = "Item not found";
              } else if (err.response?.status === 500) {
                errorMsg = "Server error occurred";
              } else if (err.response?.data?.message) {
                errorMsg = err.response.data.message;
              } else if (err.message) {
                errorMsg = err.message;
              }

              setStatusValue(cell.getValue() || "");
              setErrorStatusLoader(true);
              setErrorMessage(errorMsg);
              setIsSubmittingStatus(false);

              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          };

          return {
            select: true,
            value: currentValue,
            disabled:
              isSubmittingStatus ||
              (!hasImportUpdatePermission &&
                decodedToken?.roles?.some(
                  (role) => role.role_type !== roleTypes.SUPER_ADMIN
                )),
            error: errorStatusLoader,
            helperText: errorMessage,

            sx: {
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                "&.Mui-error fieldset": {
                  border: "none",
                },
              },

              backgroundColor: "none",

              "& .MuiSelect-select": {
                padding: "8px 12px",
                fontSize: "14px",
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                    ? "#059669"
                    : "#374151",
                backgroundColor: "none",
              },

              "& .MuiSelect-icon": {
                color: errorStatusLoader
                  ? "#ef4444 !important"
                  : successStatusLoader
                    ? "#10b981 !important"
                    : "#6b7280 !important",
                transition: "color 0.2s ease-in-out",
              },

              "& .MuiFormHelperText-root": {
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                marginLeft: "12px",
                fontWeight:
                  errorStatusLoader || successStatusLoader ? "500" : "400",
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "&.Mui-error .MuiFormHelperText-root": {
                color: "#dc2626 !important",
              },

              "& .MuiPaper-root": {
                border: "none",
              },
            },

            style: {
              position: "relative",
            },

            InputProps: {
              style: {
                position: "relative",
              },
              endAdornment: isSubmittingStatus ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "0%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <RotatingLines
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                    strokeColor="#b2b4b9"
                    color="#b2b4b9"
                    visible={true}
                  />
                </div>
              ) : null,
            },

            FormHelperTextProps: {
              sx: {
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                    ? "#059669"
                    : "#6b7280",
                fontSize: "12px",
                fontWeight:
                  errorStatusLoader || successStatusLoader ? "500" : "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            },

            onChange: async (event) => {
              const newStatus = event.target.value;
              if (newStatus === currentValue) return;
              setStatusValue(newStatus);

              await submitStatus(newStatus, row.original.id, cell);
            },
          };
        },
      },
    ],
    [
      warehouseProducts,
      selectedProductRows,
      selectedItemProduct,
      alertRefProduct,
      activeJobs,
      jobSystemsPhasesMap,
      focusedCells,
    ]
  );

  const handleSelectRowProduct = (row) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === row.original.id &&
          (!row.original.moved || row.original.moved === false)
          ? { ...product, isSelected: !product.isSelected }
          : product
      )
    );
  };

  const productColumns = useMemo(() => {
    const columns = [
      {
        id: "select",
        header: "",
        Cell: ({ row }) => (
          <Checkbox
            checked={row.original.isSelected || false}
            onChange={() => handleSelectRowProduct(row)}
          />
        ),
        size: 40,
      },
      {
        accessorKey: "warehouse_product_quantity",
        header: "Quantity",
        size: 100,
      },
      { accessorKey: "manufacturer", header: "Make", size: 100 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorKey: "description", header: "Description", size: 150 },

      { accessorKey: "sku", header: "SKU", size: 150 },
      {
        accessorKey: "aggregated_search_text",
        header: "Searchable Text",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: false,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      {
        accessorKey: "jobs",
        header: "jobs",
        size: 150,
        Cell: ({ row }) => {
          const jobs = row.original.jobs;

          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
              }}
              className="hide-scrollbar"
            >
              <span>{jobs}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "systems",
        header: "Systems",
        size: 150,
        Cell: ({ row }) => {
          const systems = row.original.systems;
          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
              }}
              className="hide-scrollbar"
            >
              <span>{systems}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "phases",
        header: "Phases",
        size: 150,
        Cell: ({ row }) => {
          const phases = row.original.phases;
          return (
            <div
              style={{
                display: "flex",
                gap: "8px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                maxWidth: "90%",
                lineHeight: "1.2",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              className="hide-scrollbar"
            >
              <span>{phases}</span>
            </div>
          );
        },
      },
       {
        accessorKey: "status",
        header: "Status",
        Cell: ({ row }) => (
          <span className={`badge ${getColorByStatus(row.original.status)}`}>
            {row.original.status}
          </span>
        ),
      },
    ];

    return columns;
  }, [type, selectedProductRows, selectedItemProduct]);

  const [draggingRowProduct, setDraggingRowProduct] = useState(null);
  const [draggingRowProductItem, setDraggingRowProductItem] = useState(null);
  const [hoveredTableProduct, setHoveredTableProduct] = useState(null);
  const [hoveredTableProductItem, setHoveredTableProductItem] = useState(null);

  const warehouseProductsTableProps = {
    enableRowDragging: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiSelectCheckboxProps: {
      color: "secondary",
    },
    muiTableContainerProps: {
      sx: {
        minHeight: "320px",
      },
    },
    onDraggingRowChange: setDraggingRowProduct,
    state: {
      draggingRowProduct,
      pagination: warehouseProductsPagination,
      globalFilter: warehouseProductsGlobalFilter,
    },
    manualPagination: true,
    manualFiltering: false,
    onPaginationChange: setWarehouseProductsPagination,
    onGlobalFilterChange: setWarehouseProductsGlobalFilter,
    rowCount: totalWarehouseProductsRecords,
    globalFilterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.trim() === "") return true;

      const searchWords = filterValue
        .toLowerCase()
        .replace(/[-+]/g, "")
        .trim()
        .split(/\s+/);
      const searchableText = (
        row.original.warehouse_aggregated_search_text ||
        row.original.searchable_text ||
        ""
      ).toLowerCase();

      return searchWords.every((word) => searchableText.includes(word));
    },
  };

  const warehouseProductsItemsTableProps = {
    enableRowDragging: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiSelectCheckboxProps: {
      color: "secondary",
    },
    muiTableContainerProps: {
      sx: {
        minHeight: "320px",
      },
    },
    onDraggingRowChange: setDraggingRowProductItem,
    state: { draggingRowProductItem },
  };

  const commonTableProps = {
    selection: true,
    autoResetPageIndex: false,
    enableRowDragging: true,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiSelectCheckboxProps: {
      color: "secondary",
    },

    muiTableContainerProps: {
      sx: {
        minHeight: "320px",
        "& .mrt-highlight-text": {
          backgroundColor: "transparent !important",
          color: "inherit !important",
        },
      },
    },

    onDraggingRowChange: setDraggingRowProduct,
    state: { draggingRowProduct, pagination, globalFilter },
    manualPagination: true,
    manualFiltering: false,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    rowCount: totalRecords,
    globalFilterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.trim() === "") return true;

      const searchWords = filterValue
        .toLowerCase()
        .replace(/[-+]/g, "")
        .trim()
        .split(/\s+/);
      const searchableText = (
        row.original.aggregated_search_text || ""
      ).toLowerCase();

      return searchWords.every((word) => searchableText.includes(word));
    },
  };

  const enhancedWarehouseProducts = useMemo(() => {
    const filteredProducts =
      filterWarehouseProducts(
        warehouseProducts,
        warehouseProductsGlobalFilter
      ) || [];

    setTotalWarehouseProductsRecords(filteredProducts.length);
    const sortedProducts = [...filteredProducts].sort((a, b) => {
      const isAWarehouseImport =
        a.product_selection === "warehouse" && a.warehouse_id;
      const isBWarehouseImport =
        b.product_selection === "warehouse" && b.warehouse_id;

      if (isAWarehouseImport && isBWarehouseImport) {
        return 0;
      }

      if (isAWarehouseImport && !isBWarehouseImport) {
        return -1;
      }

      if (!isAWarehouseImport && isBWarehouseImport) {
        return 1;
      }

      return 0;
    });

    const paginatedProducts = getWarehouseProductsPaginatedData(
      sortedProducts,
      warehouseProductsPagination.pageIndex,
      warehouseProductsPagination.pageSize
    );

    return paginatedProducts.map((product) => ({
      ...product,
    }));
  }, [
    warehouseProducts,
    warehouseProductsGlobalFilter,
    warehouseProductsPagination.pageIndex,
    warehouseProductsPagination.pageSize,
  ]);

  const tableWarehouseProduct = useMaterialReactTable({
    ...warehouseProductsTableProps,
    columns: warehouseProductColumns,
    enableColumnFilters: false,
    data: enhancedWarehouseProducts,

    getRowId: (originalRow) => `warehouse-product-${originalRow.id}`,
    muiRowDragHandleProps: {
      onDragEnd: () => { },
    },
    muiTableBodyRowProps: ({ row, table }) => {
      const warehouseRows = table
        .getRowModel()
        .rows.filter((r) => r.original?.product_selection === "warehouse");

      const lastWarehouseRowId = warehouseRows[warehouseRows.length - 1]?.id;
      const isLastWarehouseRow = row.id === lastWarehouseRowId;
      const isNewlyAdded = movingProducts.has(row.original.id);

      return {
        sx: {
          backgroundColor:
            row.original?.product_selection === "warehouse"
              ? "#ecf2f9c2"
              : "inherit",
          ...(isLastWarehouseRow
            ? {
              borderBottom: "2px solid #d1d7dccc",
              boxShadow: "0px 6px 13px #d1d7dccc, 0px 12px 18px #d1d7dccc",
            }
            : {}),

          ...(isNewlyAdded && {
            transform: "translateX(0)",
            opacity: 1,
            transition: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
            backgroundColor: "#216ddc1a",
            animation: "slideInFromLeft 0.6s ease-out forwards",
            "@keyframes slideInFromLeft": {
              "0%": {
                transform: "translateX(-100%)",
                opacity: 0,
              },
              "100%": {
                transform: "translateX(0)",
                opacity: 1,
              },
            },
          }),
        },
      };
    },
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("warehouse-product"),
      sx: {
        outline:
          hoveredTableProduct === "warehouse-product"
            ? "2px dashed #216CDC"
            : undefined,
        position: "relative",
        overflow: "visible",
      },
      sm: {
        outline:
          hoveredTableProduct === "warehouse-product"
            ? "2px dashed #216CDC"
            : undefined,
        borderBottom: "2px solid #d1d7dccc",
        boxShadow: "0px 6px 13px #d1d7dccc, 0px 12px 18px #d1d7dccc",
      },
    },
    muiBottomToolbarProps: {
      className: "compact-pagination-toolbar",
    },
    muiTopToolbarProps: {
      className: "compact-pagination-topbar",
    },
  });

  const tableWarehouseProductItems = useMaterialReactTable({
    ...warehouseProductsItemsTableProps,
    columns: warehouseProductItemsColumns,
    enableColumnFilters: false,
    data: productItems?.length ? productItems : [],
    enableEditing: true,
    editDisplayMode: "table",
    createDisplayMode: "row",
    getRowId: (originalRow) => `warehouse-product-item-${originalRow.id}`,

    muiTableContainerProps: {
      sx: {
        maxWidth: "100%",
        overflow: "auto",
        minHeight: "320px",
        position: "relative",
      },
    },

    muiTableBodyProps: {
      sx: {
        "& .MuiTableRow-root": {
          position: "relative",
        },
      },
    },

    muiTableBodyCellProps: {
      sx: {
        position: "relative",
        verticalAlign: "top",
        "&:focus, &:focus-visible, &:hover": { outline: "none" },
      },
    },

    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProductItem("warehouse-product-item"),
      sx: {
        outline:
          hoveredTableProductItem === "warehouse-product-item"
            ? "2px dashed #216CDC"
            : undefined,
        width: "100%",
        overflow: "hidden",
        position: "relative",
      },
    },

    renderEmptyRowsFallback: () =>
      !itemsLoader && (
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
            color: "#6c757d",
          }}
        >
          This product currently has no items. The quantity may have reached
          zero
        </div>
      ),
    state: {
      isLoading: itemsLoader,
      ...warehouseProductsItemsTableProps.state,
    },
    muiBottomToolbarProps: { className: "compact-pagination-toolbar" },
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
  });

  const filterProducts = (products, searchValue) => {
    if (!searchValue || searchValue.trim() === "") {
      return products;
    }

    const searchWords = searchValue
      .toLowerCase()
      .trim()
      .replace(/[-+]/g, "")
      .split(/\s+/);

    return products.filter((product) => {
      const searchableText = (
        product.aggregated_search_text || ""
      ).toLowerCase();

      return searchWords.every((word) => searchableText.includes(word));
    });
  };

  const enhancedProducts = useMemo(() => {
    const filteredProducts = filterProducts(products, globalFilter);

    setTotalRecords(filteredProducts.length);

    const paginatedProducts = getPaginatedData(
      filteredProducts,
      pagination.pageIndex,
      pagination.pageSize
    );

    return paginatedProducts.map((product) => ({
      ...product,
    }));
  }, [products, globalFilter, pagination.pageIndex, pagination.pageSize]);

  const animationStyles = {
    sourceRowMoving: {
      opacity: 0.3,
      transform: "scale(0.95)",
      transition: "all 0.8s ease-out",
      backgroundColor: "#e3f2fd",
      position: "relative",
      zIndex: 1,
    },

    flyingRow: {
      position: "fixed",
      zIndex: 9999,
      backgroundColor: "#4285f4",
      color: "white",
      borderRadius: "8px",
      padding: "12px 16px",
      boxShadow: "0 8px 32px #216ddc1a",
      transform: "scale(1.05)",
      transition: "all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      minWidth: "400px",
    },

    targetSlot: {
      backgroundColor: "#216ddc1a",
      borderRadius: "4px",
      transition: "all 0.3s ease",
      opacity: 0.7,
    },

    landedRow: {
      backgroundColor: "#216ddc1a",
      transform: "scale(1)",
      transition: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
      animation: "landingPulse 1s ease-out",
    },
  };

  const animatedMoveProduct = async (product, isMultiple = false) => {
    const productId = product.id;

    setAnimatingRows((prev) => new Set([...prev, productId]));
    setMovingProducts((prev) => new Set([...prev, productId]));

    await new Promise((resolve) => setTimeout(resolve, 500));

    setTimeout(() => {
      setAnimatingRows((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });

      setMovingProducts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }, 400);
  };

  const [rowHoverPopoverOpen, setRowHoverPopoverOpen] = useState(false);
  const [rowHoverPopoverAnchor, setRowHoverPopoverAnchor] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const hoverTimeoutRef = useRef(null);

  const tableProduct = useMaterialReactTable({
    ...commonTableProps,
    columns: productColumns,
    data: enhancedProducts,
    enableColumnFilters: false,
    defaultColumn: {
      size: 100,
    },
    getRowId: (originalRow) => `product-${originalRow.id}`,

    muiRowDragHandleProps: ({ row }) => ({
      title:
        row.original.status === "in-active" || row.original.moved
          ? "Cannot move this item"
          : "Drag to move",
      "data-no-tooltip": true,
      onDragStart: () => {
        setRowHoverPopoverOpen(false);
        setRowHoverPopoverAnchor(null);
        setHoveredRowId(null);
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current);
          hoverTimeoutRef.current = null;
        }
      },
      onDragEnd: async () => {
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
        if (hoveredTableProduct === "warehouse-product") {
          const selectedRowsToMove = products.filter(
            (product) =>
              product.isSelected &&
              product.status !== "in-active" &&
              (!product?.moved || product?.moved === false)
          );

          if (selectedRowsToMove && selectedRowsToMove.length > 0) {
            const conflictRows = selectedRowsToMove.filter((rowToMove) => {
              return selectedProductRows.some((selectedRow) => {
                return (
                  selectedRow.id === rowToMove.id &&
                  rowToMove.product_selection === "warehouse"
                );
              });
            });

            if (conflictRows.length > 0) {
              setAlerts({
                message:
                  "This product has already been imported from another warehouse. Please save your changes before dragging it.",
                type: "danger",
                show: true,
                alertFor: "products",
              });
              setTimeout(() => {
                setAlerts({
                  show: false,
                  alertFor: "",
                  message: "",
                  type: "",
                });
              }, 3000);
              return;
            }

            selectedRowsToMove.forEach(addProductToWarehouse); // Add selected rows to product
            setWarehouseProducts((prevWarehouseProducts) => {
              let updatedWarehouseProducts = [...prevWarehouseProducts];

              selectedRowsToMove.forEach((product) => {
                const existingProductIndex = updatedWarehouseProducts.findIndex(
                  (item) => item.id === product.id
                );

                let updatedProduct;
                if (existingProductIndex !== -1) {
                  updatedProduct = {
                    ...updatedWarehouseProducts[existingProductIndex],
                    ...product,
                    new_product_quantity:
                      updatedWarehouseProducts[existingProductIndex]
                        .new_product_quantity || 0,
                    product_min_quantity_notify:
                      updatedWarehouseProducts[existingProductIndex]
                        .product_min_quantity_notify || 0,
                    product_selection: product?.product_warehouse
                      ? "warehouse"
                      : product?.product_selection,
                    default_bin_id:
                      updatedWarehouseProducts[existingProductIndex]
                        .default_bin_id || null,
                    column_number:
                      updatedWarehouseProducts[existingProductIndex]
                        .column_number || null,
                    row_number:
                      updatedWarehouseProducts[existingProductIndex]
                        .row_number || null,
                    rack_name:
                      updatedWarehouseProducts[existingProductIndex]
                        .rack_name || null,
                    rack_number:
                      updatedWarehouseProducts[existingProductIndex]
                        .rack_number || null,
                    rack_id:
                      updatedWarehouseProducts[existingProductIndex].rack_id ||
                      null,
                  };

                  updatedWarehouseProducts.splice(existingProductIndex, 1);
                } else {
                  updatedProduct = {
                    ...product,
                    new_product_quantity: 0,
                    product_min_quantity_notify: 0,
                    product_selection: product?.product_warehouse
                      ? "warehouse"
                      : product?.product_selection,
                    default_bin_id: null,
                    column_number: null,
                    row_number: null,
                    rack_name: null,
                    rack_number: null,
                    rack_id: null,
                  };
                }
                updatedWarehouseProducts.unshift(updatedProduct);
              });

              return updatedWarehouseProducts;
            });

            setProducts((prevProducts) =>
              prevProducts.map((product) =>
                product.isSelected ? { ...product, moved: true } : product
              )
            );

            await Promise.all(
              selectedRowsToMove.map((data) => animatedMoveProduct(data, true))
            );
          } else if (
            draggingRowProduct.original.status !== "in-active" &&
            draggingRowProduct?.original?.moved === false
          ) {
            const conflictExists = selectedProductRows.some(
              (row) =>
                row.id === draggingRowProduct?.original?.id &&
                row.product_selection === "warehouse"
            );

            if (conflictExists) {
              setAlerts({
                message:
                  "This product has already been imported from another warehouse. Please save your changes before dragging it.",
                type: "danger",
                show: true,
                alertFor: "products",
              });
              setTimeout(() => {
                setAlerts({
                  show: false,
                  alertFor: "",
                  message: "",
                  type: "",
                });
              }, 3000);
              return;
            }
            setProducts((prevProducts) =>
              prevProducts.map((product) =>
                product.id === draggingRowProduct.original.id
                  ? { ...product, moved: true }
                  : product
              )
            );
            await animatedMoveProduct(draggingRowProduct.original);
            // addProductToWarehouse(draggingRowProduct.original);
            setWarehouseProducts((prevWarehouseProducts) => {
              const existingProductIndex = prevWarehouseProducts.findIndex(
                (item) => item.id === draggingRowProduct.original.id
              );

              let updatedProduct;
              if (existingProductIndex !== -1) {
                updatedProduct = {
                  ...prevWarehouseProducts[existingProductIndex],
                  ...draggingRowProduct.original,
                  new_product_quantity:
                    prevWarehouseProducts[existingProductIndex]
                      .new_product_quantity || 0,
                  product_min_quantity_notify:
                    prevWarehouseProducts[existingProductIndex]
                      .product_min_quantity_notify || 0,
                  product_selection: draggingRowProduct.original
                    ?.product_warehouse
                    ? "warehouse"
                    : draggingRowProduct.original?.product_selection,
                  default_bin_id:
                    prevWarehouseProducts[existingProductIndex]
                      .default_bin_id || null,
                  column_number:
                    prevWarehouseProducts[existingProductIndex].column_number ||
                    null,
                  row_number:
                    prevWarehouseProducts[existingProductIndex].row_number ||
                    null,
                  rack_name:
                    prevWarehouseProducts[existingProductIndex].rack_name ||
                    null,
                  rack_number:
                    prevWarehouseProducts[existingProductIndex].rack_number ||
                    null,
                  rack_id:
                    prevWarehouseProducts[existingProductIndex].rack_id || null,
                };

                const updatedProducts = [...prevWarehouseProducts];
                updatedProducts.splice(existingProductIndex, 1);

                addProductToWarehouse(updatedProduct);
                return [updatedProduct, ...updatedProducts];
              }

              updatedProduct = {
                ...draggingRowProduct.original,
                new_product_quantity: 0,
                product_min_quantity_notify: 0,
                product_selection: draggingRowProduct.original
                  ?.product_warehouse
                  ? "warehouse"
                  : draggingRowProduct.original?.product_selection,
                default_bin_id: null,
                column_number: null,
                row_number: null,
                rack_name: null,
                rack_number: null,
                rack_id: null,
              };

              addProductToWarehouse(updatedProduct);
              return [updatedProduct, ...prevWarehouseProducts];
            });
          } else {
            if (draggingRowProduct.original.status === "in-active") {
              setAlerts({
                alertFor: "products",
                type: "danger",
                message: "This product cannot be moved as it is inactive",
                show: true,
              });

              setTimeout(() => {
                setAlerts({
                  show: false,
                  alertFor: "",
                  message: "",
                  type: "",
                });
              }, 5000);
            }
          }
        }
        setHoveredTableProduct(null);
      },
      onMouseEnter: (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isInactive = row.original.status === "in-active";
        const isMoved = row.original.moved;

        if (!isInactive && !isMoved) {
          event.preventDefault();
          event.stopPropagation();
          setDragPopoverAnchor(event.currentTarget);
          setDragPopoverOpen(true);
        }
      },

      onMouseLeave: (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
        setTimeout(() => {
          setDragPopoverOpen(false);
          setDragPopoverAnchor(null);
        }, 100);
      },

      sx: {
        cursor:
          row.original.status === "in-active" || row.original.moved
            ? "not-allowed"
            : "grab",
        opacity:
          row.original.status === "in-active" || row.original.moved ? 0.3 : 1,
        "&:hover": {
          backgroundColor:
            row.original.status !== "in-active" && !row.original.moved
              ? "rgba(33, 108, 220, 0.1)"
              : "transparent",
        },
        "&:active": {
          cursor:
            row.original.status === "in-active" || row.original.moved
              ? "not-allowed"
              : "grabbing",
        },
        transition: "all 0.2s ease",
      },
    }),
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("product"),
      sx: {
        outline:
          hoveredTableProduct === "product" ? "2px dashed #216CDC" : undefined,
      },
    },

    renderEmptyRowsFallback: () => (
      <div
        style={{
          textAlign: "left",
          padding: "2rem",
          marginLeft: "12rem",
          color: "#6c757d",
        }}
      >
        No products found
      </div>
    ),
    muiTableBodyRowProps: ({ row }) => {
      const isMoved = products.some((p) => p.id === row.original.id && p.moved);
      const isInactive = row.original.status === "in-active";
      const isAnimating = animatingRows.has(row.original.id);
      const isMoving = movingProducts.has(row.original.id);
      const canMove = !isInactive && !isMoved;

      return {
        onMouseEnter: (event) => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }

          if (!canMove) {
            setRowHoverPopoverOpen(false);
            setRowHoverPopoverAnchor(null);
            setHoveredRowId(null);
            return;
          }
          if (canMove) {
            setHoveredRowId(row.original.id);
            hoverTimeoutRef.current = setTimeout(() => {
              setRowHoverPopoverAnchor(event.currentTarget);
              setMousePosition({ x: event.clientX, y: event.clientY });
              setRowHoverPopoverOpen(true);
            }, 50);
          }
        },

        onMouseMove: (event) => {
          if (
            canMove &&
            rowHoverPopoverOpen &&
            hoveredRowId === row.original.id
          ) {
            setMousePosition({ x: event.clientX, y: event.clientY });
          }
        },

        onMouseLeave: (event) => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }

          if (hoveredRowId === row.original.id) {
            hoverTimeoutRef.current = setTimeout(() => {
              setRowHoverPopoverOpen(false);
              setRowHoverPopoverAnchor(null);
              setHoveredRowId(null);
            }, 100);
          }
        },
        onClick: async (e) => {
          if (
            e.target.closest("input[type='checkbox']") ||
            e.target.closest(".MuiTableDragHandle-root") ||
            e.target.closest("svg")
          ) {
            return;
          }

          if (
            row.original.status !== "in-active" &&
            row?.original?.moved === false
          ) {
            const conflictExists = selectedProductRows.some(
              (selectedRow) =>
                selectedRow.id === row.original.id &&
                selectedRow.product_selection === "warehouse"
            );

            if (conflictExists) {
              setAlerts({
                message:
                  "This product has already been imported from another warehouse. Please save your changes before dragging it.",
                type: "danger",
                show: true,
                alertFor: "products",
              });
              setTimeout(() => {
                setAlerts({
                  show: false,
                  alertFor: "",
                  message: "",
                  type: "",
                });
              }, 3000);
              return;
            }

            // addProductToWarehouse(draggingRowProduct.original);
            setWarehouseProducts((prevWarehouseProducts) => {
              if (
                !prevWarehouseProducts ||
                !Array.isArray(prevWarehouseProducts)
              ) {
                const newProduct = {
                  ...row.original,
                  moved: true,
                  new_product_quantity: 0,
                  product_min_quantity_notify: 0,
                  product_selection: row.original?.product_warehouse
                    ? "warehouse"
                    : row.original?.product_selection,
                  default_bin_id: null,
                  column_number: null,
                  row_number: null,
                  rack_name: null,
                  rack_number: null,
                  rack_id: null,
                };
                addProductToWarehouse(newProduct);
                return [newProduct];
              }

              const existingProductIndex = prevWarehouseProducts.findIndex(
                (item) => item.id === row.original.id
              );

              let updatedProduct;
              if (existingProductIndex !== -1) {
                updatedProduct = {
                  ...prevWarehouseProducts[existingProductIndex],
                  ...row.original,
                  moved: true,
                  new_product_quantity:
                    prevWarehouseProducts[existingProductIndex]
                      .new_product_quantity || 0,
                  product_min_quantity_notify:
                    prevWarehouseProducts[existingProductIndex]
                      .product_min_quantity_notify || 0,
                  product_selection: row.original?.product_warehouse
                    ? "warehouse"
                    : row.original?.product_selection,
                  default_bin_id:
                    prevWarehouseProducts[existingProductIndex]
                      .default_bin_id || null,
                  column_number:
                    prevWarehouseProducts[existingProductIndex].column_number ||
                    null,
                  row_number:
                    prevWarehouseProducts[existingProductIndex].row_number ||
                    null,
                  rack_name:
                    prevWarehouseProducts[existingProductIndex].rack_name ||
                    null,
                  rack_number:
                    prevWarehouseProducts[existingProductIndex].rack_number ||
                    null,
                  rack_id:
                    prevWarehouseProducts[existingProductIndex].rack_id || null,
                };

                const updatedProducts = [...prevWarehouseProducts];
                updatedProducts.splice(existingProductIndex, 1);

                addProductToWarehouse(updatedProduct);
                return [updatedProduct, ...updatedProducts];
              }

              updatedProduct = {
                ...row.original,
                moved: true,
                new_product_quantity: 0,
                product_min_quantity_notify: 0,
                product_selection: row.original?.product_warehouse
                  ? "warehouse"
                  : row.original?.product_selection,
                default_bin_id: null,
                column_number: null,
                row_number: null,
                rack_name: null,
                rack_number: null,
                rack_id: null,
              };

              addProductToWarehouse(updatedProduct);
              return [updatedProduct, ...prevWarehouseProducts];
            });

            setProducts((prevProducts) =>
              prevProducts.map((product) =>
                product.id === row.original.id
                  ? { ...product, moved: true }
                  : product
              )
            );
            await animatedMoveProduct(row.original);
          } else {
            if (row.original.status === "in-active") {
              setAlerts({
                alertFor: "products",
                type: "danger",
                message: "This product cannot be moved as it is inactive",
                show: true,
              });

              setTimeout(() => {
                setAlerts({
                  show: false,
                  alertFor: "",
                  message: "",
                  type: "",
                });
              }, 5000);
            }
          }
        },
        sx: {
          backgroundColor: isInactive
            ? "#bcb8b8"
            : isMoving
              ? "#216ddc1a"
              : isMoved
                ? "#216CDC !important"
                : "inherit",
          color: isMoved ? "#ffffff !important" : "#000000",
          pointerEvents: isInactive ? "none" : "auto",
          cursor: isInactive || isMoved ? "no-drop" : "pointer",

          ...(isAnimating && animationStyles.movingRow),
          ...(isMoving && {
            transform: "translateX(-50px) scale(1.02)",
            opacity: 0.8,
            transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            boxShadow: "0 8px 25px #216ddc1a",
            zIndex: 1000,
          }),

          ...(isMoved && !isAnimating && animationStyles.pulseEffect),
          "&:hover": {
            backgroundColor: isMoved
              ? "#216CDC !important"
              : isInactive
                ? "#bcb8b8"
                : "#f8f9fa",
            color: isMoved ? "#ffffff" : "#000000",
          },
        },
      };
    },
    muiTableBodyCellProps: ({ row }) => ({
      sx: {
        color: row.original.moved ? "#ffffff" : "#000000",
        transition: "color 0.3s ease",
      },
    }),
    muiBottomToolbarProps: {
      className: "compact-pagination-toolbar",
    },
    muiTopToolbarProps: {
      className: "compact-pagination-topbar",
    },
  });

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCollapsedProduct, setIsCollapsedProduct] = useState(true);

  const [isCollapsedRack, setIsCollapsedRack] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const toggleCollapseProduct = () => {
    setIsCollapsedProduct((prev) => !prev);
  };

  const toggleCollapseRack = () => {
    setIsCollapsedRack((prev) => !prev);
  };

  const [optionWarehouses, setOptionWarehouses] = useState([]);

  useEffect(() => {
    const warehouseOptions =
      warehouses.length > 0 &&
      warehouses.map((warehouse) => ({
        value: warehouse.id,
        label: warehouse.name,
      }));
    setOptionWarehouses(warehouseOptions || []);
  }, [warehouses]);

  const handleCancelProduct = async () => {
    setSelectedProductRows([]);

    setWarehouseProducts(oldWarehouseProducts || []);

    if (products && products.length > 0) {
      setProducts((prevProducts) =>
        prevProducts.map((product) => ({
          ...product,
          moved: false,
          isSelected: false,
          warehouse_product_quantity:
            product.quantity || product.warehouse_product_quantity,
        }))
      );
    }

    setQuantityError(null);
    setMinQuantityError(null);
    setBinError(null);
    setErrors({});
    setHasUnsavedChanges(false);
    setIsSubmitProduct(true);
    setWarehouseProductSubmit(false);
    setAnimatingRows(new Set());
    setMovingProducts(new Set());
    setSelectedRackProduct(null);

    if (type) {
      await getImportProducts();
    }
  };

  const [isTable2Open, setIsTable2Open] = useState(false);
  const toggleTable2 = async () => {
    if (isTable2Open) {
      const isSafeToSwitch = await checkImportProductUpdate();

      if (!isSafeToSwitch) {
        handleUnsaveShow();
        return;
      }
    }
    setIsTable2Open((prev) => !prev);
  };

  const getStatusIcon = (status, size = 16) => {
    if (status === "active") {
      return <CheckCircle size={size} className="text-success" />;
    }
    return null;
  };

  const [rackBinLoader, setRackBinLoader] = useState(true);
  const [rackProducts, setRackProducts] = useState([]);
  const [productRackBinLoader, setProductRackBinLoader] = useState(true);

  const getWarehouseRackBins = async (rackId) => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setRackBinLoader(false);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}warehouse/${id}/rack/${rackId}`,
        config
      );

      setRackBins(response?.data?.response?.data || []);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "warehouses-rack-bin-edit");
    } finally {
      setRackBinLoader(false);
    }
  };

  const getWarehouseRackBinsProducts = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setProductRackBinLoader(false);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}warehouse/${id}/products`,
        config
      );

      setRackProducts(response?.data?.response?.data || []);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "warehouses-rack-bin-edit-products");
    } finally {
      setProductRackBinLoader(false);
    }
  };

  const handleRackClick = async (rack) => {
    setShowRackModal(true);
    setRackBinLoader(true);
    setSelectedRack(rack);
    await getWarehouseRackBins(rack.id);
  };
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleRackBinClick = async (row, col, rackBin) => {
    setSelectedRackBin({
      row,
      col,
      rackId: selectedRack.id,
      rackBinId: rackBin.id,
      productId: rackBin.productId,
      productName: rackBin.productName,
    });
    setSelectedProduct({
      value: rackBin.productId,
      label: rackBin.productName,
    });
    setShowRackBinModal(true);
    setProductRackBinLoader(true);
    await getWarehouseRackBinsProducts();
  };

  const generateRackBinLayout = (rackBins = [], totalRows, totalColumns) => {
    const layout = [];

    for (let row = totalRows; row >= 1; row--) {
      const rowRackBins = [];
      for (let col = 1; col <= totalColumns; col++) {
        const existingRackBin =
          rackBins &&
          rackBins?.length > 0 &&
          rackBins?.find(
            (bin) => bin.rowNumber === row && bin.columnNumber === col
          );

        rowRackBins.push({
          id: existingRackBin?.id || null,
          rowNumber: row,
          columnNumber: col,
          status: existingRackBin?.status || "active",
          productId: existingRackBin?.productId || null,
          productName: existingRackBin?.productName || null,
          quantity: existingRackBin?.quantity || null,
        });
      }
      layout.push(rowRackBins);
    }

    return layout;
  };

  const [optionProducts, setOptionProducts] = useState();

  useEffect(() => {
    const mappedOptions =
      rackProducts.length > 0
        ? rackProducts.map((product) => ({
          value: product.productId,
          label: product.productName,
        }))
        : [];
    const productOptions = [
      ...(selectedRackBin?.productId
        ? [
          {
            value: selectedRackBin.productId,
            label: selectedRackBin.productName,
          },
        ]
        : []),
      ...mappedOptions,
    ];

    setOptionProducts(productOptions);
  }, [rackProducts, selectedRackBin]);

  const handleAssignProduct = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      setRackBinLoader(false);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.post(
        `${url.backendURL}warehouse/${id}/rack/${selectedRackBin.rackId}/rackbin/${selectedRackBin.rackBinId}`,
        { productId: selectedProduct?.value },
        config
      );
      await getWarehouseRackBins(selectedRack.id);

      if (
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        ) ||
        hasImportUpdatePermission ||
        hasImportViewPermission ||
        hasImportDeletePermission ||
        hasAssignBinLocationPermission
      ) {
        await getWarehouseProductDetail();
        if (type) {
          await getImportProducts();
        }
        setSelectedProductRows([]);
      }

      setErrors({});
      setShowRackBinModal(false);
      setAlerts({
        message: response && response.data.message,
        type: "success",
        show: true,
        alertFor: "warehouses-rack-bin-edit-products",
      });

      setTimeout(() => {
        setAlerts({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setShowRackBinModal(false);
      handleError(err, "warehouses-rack-bin-edit-products");
    } finally {
      setRackBinLoader(false);
    }
  };

  const updateProductBinInWarehouse = (
    productId,
    selectedRack,
    selectedBin,
    product
  ) => {
    const isProductSameAsOld = (newProd) => {
      const oldProduct = oldWarehouseProducts?.find(
        (oldProd) => oldProd.id === newProd.id
      );
      return (
        oldProduct &&
        oldProduct.warehouse_id === newProd.warehouse_id &&
        oldProduct.default_bin_id === newProd.default_bin_id &&
        oldProduct.product_selection === newProd.product_selection
      );
    };

    setSelectedProductRows((prevSelectedProductRows) => {
      const updatedRows = prevSelectedProductRows.map((item) =>
        item.id === productId
          ? {
            ...item,
            default_bin_id: selectedBin?.id || null,
            rack_id: selectedRack?.rack_id || null,
            rack_name: selectedRack?.name || null,
            rack_number: selectedRack?.rack_number || null,
            column_number: selectedBin?.column_number || null,
            row_number: selectedBin?.row_number || null,
            new_status: "added",
          }
          : item
      );

      const updatedProduct = updatedRows.find((item) => item.id === productId);

      if (updatedProduct && isProductSameAsOld(updatedProduct)) {
        return updatedRows.filter((item) => item.id !== productId);
      }

      return updatedProduct ? updatedRows : [...updatedRows];
    });
  };

  const handleBinAssignToWarehouseProduct = async (
    selectedRack,
    selectedBin,
    containsSelectedProduct
  ) => {
    if (containsSelectedProduct) {
      handleError(
        "This product is already assigned to the same bin",
        "bin-list",
        "warning"
      );
      setAlerts({
        message: "This product is already assigned to the same bin",
        type: "warning",
        show: true,
        alertFor: "bin-list",
      });
      setTimeout(() => {
        setAlerts({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
    try {
      if (selectedRackProduct.warehouse_product_id) {
        const config = {
          headers: {
            Authorization: `${token}`,
          },
        };

        const response = await axios.put(
          `${url.backendURL}warehouse/${id}/product/${selectedRackProduct.id}/bin/${selectedBin.id}`,
          {},
          config
        );
        setOldWarehouseProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.id === selectedRackProduct.id) {
              return {
                ...product,
                rack_id: selectedRack.rack_id,
                rack_name: selectedRack.name,
                rack_number: selectedRack.rack_number,
                default_bin_id: selectedBin.id,
                column_number: selectedBin.column_number,
                row_number: selectedBin.row_number,
              };
            }
            return product;
          })
        );
        setAlerts({
          message: response.data.message,
          type: "success",
          show: true,
          alertFor: "bin-list",
        });
        setTimeout(() => {
          setAlerts({ show: false, alertFor: "", message: "", type: "" });
        }, 5000);
      }
      updateProductBinInWarehouse(
        selectedRackProduct.id,
        selectedRack,
        selectedBin,
        selectedRackProduct
      );
      setWarehouseProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.id === selectedRackProduct.id) {
            return {
              ...product,
              rack_id: selectedRack.rack_id,
              rack_name: selectedRack.name,
              rack_number: selectedRack.rack_number,
              default_bin_id: selectedBin.id,
              column_number: selectedBin.column_number,
              row_number: selectedBin.row_number,
            };
          }
          return product;
        })
      );
      setSelectedRackProduct({
        ...selectedRackProduct,
        rack_id: selectedRack.rack_id,
        rack_name: selectedRack.name,
        rack_number: selectedRack.rack_number,
        default_bin_id: selectedBin.id,
        column_number: selectedBin.column_number,
        row_number: selectedBin.row_number,
      });
    } catch (error) {
      if (
        error.response.data.message ===
        "This product is already assigned to the same bin"
      ) {
        handleError(error, "bin-list", "warning");
      } else {
        handleError(error, "bin-list");
      }
    }
  };
  const handleAddNewRack = () => {
    const url = `/dashboard/app/rack-add?id=${id}`;
    window.open(url, "_blank");
  };

  const handleSubmitAddRack = async () => {
    await getWarehouseRacks();
    setShowRackAddModal(false);
  };

  const NoRacksFound = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        minHeight: "400px",
        padding: "2rem",
      }}
    >
      <Package2 className="text-muted mb-3" size={64} />
      <h4 className="text-dark mb-2">No Racks Found</h4>
      <p className="text-muted mb-3">
        {searchTerm ? (
          <>
            No racks match your search criteria. Try adjusting your search terms
            {(rackManagementHasCreatePermission ||
              decodedToken?.roles?.some(
                (role) => role.role_type === roleTypes.SUPER_ADMIN
              )) && (
                <>
                  {statusFilter !== "all" && " or filter criteria"}
                  {" or "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddNewRack();
                    }}
                    className="text-primary text-decoration-none"
                    style={{
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    Install Racks
                  </a>
                </>
              )}
          </>
        ) : (
          <>
            There are no racks available in this warehouse,
            {(rackManagementHasCreatePermission ||
              decodedToken?.roles?.some(
                (role) => role.role_type === roleTypes.SUPER_ADMIN
              )) && (
                <>
                  {" "}
                  or{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddNewRack();
                    }}
                    className="text-primary text-decoration-none"
                    style={{
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    {" "}click here{" "}
                  </a>
                  to install some racks
                </>
              )}
          </>
        )}
      </p>
    </div>
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            id: warehouse?.id,
            name: warehouse?.name,
            identityNumber: warehouse?.identity_number,
            type: warehouse?.type,
            address: warehouse?.address,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            resetForm,
          }) => (
            <Form onSubmit={handleSubmit}>
              <FocusError />
              <Row ref={alertRef}>
                <Col sm="12">
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div
                        className="header-title breadcrumb"
                        style={{ cursor: "pointer" }}
                        onClick={toggleCollapse}
                      >
                        <h4
                          onClick={() =>
                            navigate("/dashboard/app/warehouse-list")
                          }
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Warehouse</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title pb-3">
                          {warehouse && warehouse?.name}{" "}
                        </h4>
                      </div>
                      <div>
                        {isCollapsed && warehouse ? (
                          <>
                            <div
                              onClick={toggleCollapse}
                              className="sidebar-toggle"
                              style={{
                                position: "initial",
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="icon"
                                style={{ transform: "rotate(270deg)" }}
                              >
                                <svg
                                  width="20"
                                  className="icon-20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.25 12.2744L19.25 12.2744"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                              </i>
                            </div>
                          </>
                        ) : (
                          warehouse && (
                            <>
                              <div
                                className="sidebar-toggle"
                                onClick={toggleCollapse}
                                style={{
                                  position: "initial",
                                  marginRight: "1.5rem",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  className="icon"
                                  style={{ transform: "rotate(90deg)" }}
                                >
                                  <svg
                                    width="20"
                                    className="icon-20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.25 12.2744L19.25 12.2744"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </i>
                              </div>
                            </>
                          )
                        )}
                      </div>
                    </Card.Header>
                    {!isCollapsed && (
                      <Card.Body>
                        {alerts.alertFor === "information" && (
                          <AlertNotificationSimple
                            type={alerts.type}
                            message={alerts.message}
                            show={alerts.show}
                            onClose={() =>
                              setAlerts({ ...alerts, show: false })
                            }
                          />
                        )}
                        {!loader && warehouse && (
                          <div className="new-user-info">
                            <div className="row">
                              <InputField
                                className="col-md-6 form-group"
                                type="text"
                                name="name"
                                placeholder="Enter name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.name}
                                label="Name"
                                disabled={
                                  !hasUpdatePermission &&
                                  decodedToken?.roles?.some(
                                    (role) =>
                                      role.role_type !== roleTypes.SUPER_ADMIN
                                  )
                                }
                              />

                              <InputField
                                className="col-md-6 form-group"
                                type="text"
                                name="identityNumber"
                                placeholder="Enter identity number"
                                value={values.identityNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.identityNumber}
                                label="Identity Number"
                                disabled={true}
                              />

                              <InputField
                                className="col-md-6 form-group"
                                type="text"
                                name="address"
                                placeholder="Enter address"
                                value={values.address}
                                onChange={handleChange}
                                asterick={true}
                                onBlur={handleBlur}
                                label="Address"
                                errorMessage={errors?.address}
                                disabled={
                                  !hasUpdatePermission &&
                                  decodedToken?.roles?.some(
                                    (role) =>
                                      role.role_type !== roleTypes.SUPER_ADMIN
                                  )
                                }
                              />
                              <Form.Group className="col-md-6 form-group">
                                <Form.Label htmlFor="type">
                                  Warehouse Type
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                  closeMenuOnScroll={(e) => {
                                    try {
                                      const target = e.target;

                                      if (
                                        !target ||
                                        !target.nodeType ||
                                        typeof target.closest !== "function"
                                      ) {
                                        return true;
                                      }

                                      const isMenuScroll =
                                        target.closest('[class*="MenuList"]') ||
                                        target.closest('[class*="menu"]');

                                      return !isMenuScroll;
                                    } catch (error) {
                                      return true;
                                    }
                                  }}
                                  id="type"
                                  options={[
                                    { value: "physical", label: "Physical" },
                                    { value: "van", label: "Van" },
                                  ]}
                                  isDisabled={
                                    !hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    )
                                  }
                                  value={
                                    values.type
                                      ? {
                                        value: values.type,
                                        label:
                                          values.type
                                            .charAt(0)
                                            .toUpperCase() +
                                          values.type.slice(1),
                                      }
                                      : null
                                  }
                                  onChange={(option) => {
                                    if (option) {
                                      setFieldValue("type", option.value);
                                    } else {
                                      setFieldValue("type", null);
                                    }
                                  }}
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  menuPlacement="auto"
                                  onBlur={handleBlur}
                                  isClearable
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      color: "#5e667b",
                                    }),
                                  }}
                                />

                                <ErrorMessage
                                  name="type"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>

                              <hr />
                              <div className="d-flex justify-content-end align-items-end">
                                <Button
                                  type="button"
                                  className="btn btn-light me-4"
                                  variant="btn btn-light"
                                  onClick={() => resetFormData(resetForm)}
                                  disabled={
                                    isSubmitting ||
                                    (!hasUpdatePermission &&
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type !==
                                          roleTypes.SUPER_ADMIN
                                      ))
                                  }
                                >
                                  Reset
                                </Button>
                                <Button
                                  variant="primary"
                                  type="submit"
                                  className="me-4"
                                  disabled={
                                    isSubmitting ||
                                    (!hasUpdatePermission &&
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type !==
                                          roleTypes.SUPER_ADMIN
                                      ))
                                  }
                                >
                                  Update
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                        {loader && <FadeLoaderComponent />}
                      </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
      {openRackModal && (
        <RackBinModal
          show={openRackModal}
          onHide={() => setOpenRackModal(false)}
          selectedRackProduct={selectedRackProduct}
          warehouseProducts={warehouseProducts}
          token={token}
          decodedToken={decodedToken}
          setWarehouseProducts={setWarehouseProducts}
          setSelectedRackProduct={setSelectedRackProduct}
          handleBinAssignToWarehouseProduct={handleBinAssignToWarehouseProduct}
          alerts={alerts}
          setAlertResponse={setAlerts}
        />
      )}

      {(hasImportDeletePermission ||
        hasImportUpdatePermission ||
        hasImportViewPermission ||
        hasAssignBinLocationPermission ||
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )) && (
          <div>
            {warehouse && (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (isSubmitProduct) {
                    setIsSubmitProduct(false);
                    setWarehouseProductSubmit(true);
                    handleSubmitProduct(e);
                  }
                }}
              >
                <Row>
                  <Col sm={12} ref={alertRefProduct}>
                    <Card>
                      <Card.Header className="d-flex justify-content-between">
                        <div
                          className="header-title pb-3"
                          style={{ cursor: "pointer" }}
                        >
                          {viewProduct ? (
                            <div
                              className="breadcrumb header-title"
                              style={{ cursor: "pointer" }}
                            >
                              <h4
                                onClick={() =>
                                  navigate("/dashboard/app/warehouse-list")
                                }
                                className="text-primary card-title"
                                style={{ cursor: "pointer" }}
                              >
                                <span>Warehouse</span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>

                              <h4 className="card-title">Products</h4>
                            </div>
                          ) : showHistoryView ? (
                            <div
                              className="breadcrumb  header-title"
                              style={{ cursor: "pointer" }}
                            >
                              <h4
                                onClick={() =>
                                  navigate("/dashboard/app/warehouse-list")
                                }
                                className="text-primary card-title"
                                style={{ cursor: "pointer" }}
                              >
                                <span>Warehouse</span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>
                              <h4 className="text-primary card-title cursor-pointer">
                                <span onClick={handleItemsClose}>Products</span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>
                              <h4 className="text-primary card-title cursor-pointer">
                                <span onClick={() => setShowHistoryView(false)}>
                                  Items
                                </span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>
                              <h4 className="card-title">History</h4>
                            </div>
                          ) : (
                            <div
                              className="breadcrumb  header-title"
                              style={{ cursor: "pointer" }}
                            >
                              <h4
                                onClick={() =>
                                  navigate("/dashboard/app/warehouse-list")
                                }
                                className="text-primary card-title"
                                style={{ cursor: "pointer" }}
                              >
                                <span>Warehouse</span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>
                              <h4 className="text-primary card-title cursor-pointer">
                                <span onClick={handleItemsClose}>Products</span>
                              </h4>
                              <h4 className="mx-2 card-title">{">"}</h4>
                              <h4 className="card-title">Items</h4>
                            </div>
                          )}
                        </div>
                        <div>
                          {isCollapsedProduct ? (
                            <>
                              <div
                                onClick={toggleCollapseProduct}
                                className="sidebar-toggle"
                                style={{
                                  position: "initial",
                                  marginRight: "1.5rem",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  className="icon"
                                  style={{ transform: "rotate(270deg)" }}
                                >
                                  <svg
                                    width="20"
                                    className="icon-20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.25 12.2744L19.25 12.2744"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </i>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="sidebar-toggle"
                                onClick={toggleCollapseProduct}
                                style={{
                                  position: "initial",
                                  marginRight: "1.5rem",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  className="icon"
                                  style={{ transform: "rotate(90deg)" }}
                                >
                                  <svg
                                    width="20"
                                    className="icon-20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.25 12.2744L19.25 12.2744"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </i>
                              </div>
                            </>
                          )}
                        </div>
                      </Card.Header>
                      {!isCollapsedProduct && (
                        <Card.Body>
                          {alerts.alertFor === "products" && (
                            <AlertNotificationSimple
                              type={alerts.type}
                              message={alerts.message}
                              show={alerts.show}
                              onClose={() =>
                                setAlerts({ ...alerts, show: false })
                              }
                            />
                          )}

                          {viewProduct && (
                            <Row className="m-0 p-0">
                              <Col md={12} className="m-0 p-0">
                                <div
                                  className="d-flex align-items-end justify-content-end"
                                  style={{
                                    width: "100%",
                                    justifyContent: "flex-end !important",
                                  }}
                                >
                                  {/* Right Icon */}
                                  {(hasImportUpdatePermission ||
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type === roleTypes.SUPER_ADMIN
                                    )) && (
                                      <div
                                        className="d-flex align-items-end justify-content-end w-100 z-100"
                                        style={{ zIndex: "111" }}
                                      >
                                        <Button
                                          onClick={toggleTable2}
                                          className="pulse-button rounded-circle p-2"
                                          title="Warehouse Products"
                                          style={{
                                            color: "gray",
                                            background: "#dadada8a",
                                            border: "none",
                                            position: "relative",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <ChevronRight
                                            className={`rotate-icon ${isTable2Open
                                              ? "rotate-0"
                                              : "rotate-180"
                                              }`}
                                            size={24}
                                          />
                                        </Button>
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          )}

                          {viewProduct && (
                            <Row
                              className="d-flex"
                              style={{
                                flexDirection: isMobile ? "column" : "row",
                              }}
                            >
                              <Col
                                md={12}
                                sm={12}
                                className="m-0 p-0"
                                style={{
                                  width: isMobile
                                    ? "100%"
                                    : isTable2Open
                                      ? "50%"
                                      : "100%",

                                  transition: "width 0.5s ease-in-out",
                                  flex: "0 0 auto",
                                }}
                              >
                                <Card.Header className="d-flex justify-content-between w-100 ">
                                  <div
                                    className="header-title header-title"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <h5 className="card-title">
                                      Products{" "}
                                      <span
                                        className="text-gray"
                                        style={{ fontSize: "17px" }}
                                      >
                                        {"(" + warehouse?.name + ")"}
                                      </span>
                                    </h5>
                                  </div>
                                </Card.Header>

                                <div className="d-flex align-items-center justify-content-between"></div>
                                <Card.Body className="ps-xl-4 ps-md-2">
                                  <Box
                                    sx={{
                                      gap: { sm: "1rem" },
                                      overflow: { sm: "auto" },
                                      py: { sm: "4px" },
                                      width: { sm: "100%" },
                                      marginTop: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "3rem",
                                        sm: "3rem",
                                        xs: "0rem",
                                      },
                                    }}
                                  >
                                    {quantityError && (
                                      <span className="w-100 mt-1 small text-danger">
                                        {quantityError}
                                        <br />
                                      </span>
                                    )}

                                    {minQuantityError && (
                                      <span className="w-100 mt-1 small text-danger">
                                        {minQuantityError}
                                        <br />
                                      </span>
                                    )}

                                    {binError && (
                                      <span className="w-100 mt-1 small text-danger">
                                        {binError}
                                        <br />
                                      </span>
                                    )}
                                    <MaterialReactTable
                                      table={tableWarehouseProduct}
                                    />

                                    <div style={{ marginTop: "2rem" }}></div>

                                    <hr className="order-button" />
                                    {(hasImportUpdatePermission ||
                                      hasImportDeletePermission ||
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type === roleTypes.SUPER_ADMIN
                                      )) && (
                                        <div
                                          className="order-button justify-content-end align-items-end"
                                          style={{ marginTop: "2rem" }}
                                        >
                                          <Button
                                            type="button"
                                            className="btn btn-light me-4"
                                            variant="btn btn-light"
                                            onClick={() => {
                                              handleCancelProduct();
                                              setIsTable2Open(false);
                                            }}
                                          >
                                            Reset
                                          </Button>
                                          <Button
                                            variant="primary"
                                            type="submit"
                                            className="me-4"
                                            disabled={warehouseProductSubmit}
                                          >
                                            Update
                                          </Button>
                                        </div>
                                      )}
                                  </Box>
                                </Card.Body>
                              </Col>

                              {(hasImportUpdatePermission ||
                                decodedToken?.roles?.some(
                                  (role) =>
                                    role.role_type === roleTypes.SUPER_ADMIN
                                )) && (
                                  <Col
                                    md={12}
                                    sm={12}
                                    className="m-0 p-0"
                                    style={{
                                      width: isMobile
                                        ? isTable2Open
                                          ? "100%"
                                          : "0%"
                                        : isTable2Open
                                          ? "50%"
                                          : "0%",

                                      opacity: isTable2Open ? 1 : 0,
                                      transition:
                                        "width 0.5s ease-in-out, opacity 0.3s ease-in-out",
                                      overflow: "hidden",
                                      visibility: isTable2Open
                                        ? "visible"
                                        : "hidden",
                                      height: isTable2Open ? "auto" : "0px",

                                      position: "relative",
                                      maxWidth: isMobile ? "100%" : "50%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        opacity: isTable2Open ? 1 : 0,
                                        transform: isTable2Open
                                          ? "translateX(0)"
                                          : "translateX(20px)",
                                        transition:
                                          "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                                      }}
                                    >
                                      <>
                                        <Card.Header className="d-flex justify-content-between ps-0">
                                          <div className="w-100">
                                            <Row>
                                              <Col
                                                xl={6}
                                                sm={12}
                                                className="mb-sm-2 mb-2"
                                              >
                                                <h5 className="card-title d-flex align-items-stretch flex-row">
                                                  Import Products
                                                </h5>
                                              </Col>
                                              <Col xl={6} sm={12}>
                                                <Select
                                                  closeMenuOnScroll={(e) => {
                                                    try {
                                                      const target = e.target;

                                                      if (
                                                        !target ||
                                                        !target.nodeType ||
                                                        typeof target.closest !==
                                                        "function"
                                                      ) {
                                                        return true;
                                                      }

                                                      const isMenuScroll =
                                                        target.closest(
                                                          '[class*="MenuList"]'
                                                        ) ||
                                                        target.closest(
                                                          '[class*="menu"]'
                                                        );

                                                      return !isMenuScroll;
                                                    } catch (error) {
                                                      return true;
                                                    }
                                                  }}
                                                  id="type"
                                                  options={[...optionWarehouses]}
                                                  value={
                                                    optionWarehouses.length > 0
                                                      ? optionWarehouses?.find(
                                                        (option) =>
                                                          option?.value === type
                                                      )
                                                      : null
                                                  }
                                                  placeholder="Select from warehouse..."
                                                  onChange={async (option) => {
                                                    const isSafeToSwitch =
                                                      await checkImportProductUpdate(
                                                        option?.value
                                                      );

                                                    if (!isSafeToSwitch) {
                                                      setSelectedWarehouseOption(
                                                        option?.value || null
                                                      );
                                                      handleUnsaveShow();
                                                      return;
                                                    }

                                                    setPagination({
                                                      pageIndex: 0,
                                                      pageSize: 10,
                                                    });
                                                    if (option) {
                                                      setType(option?.value);
                                                    } else {
                                                      setType(null);
                                                      setProducts([]);
                                                    }
                                                  }}
                                                  menuPortalTarget={document.body}
                                                  menuPosition="fixed"
                                                  menuPlacement="auto"
                                                  isClearable
                                                  styles={{
                                                    control: (provided) => ({
                                                      ...provided,
                                                      color: "#5e667b",
                                                    }),
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card.Header>

                                        <div className="d-flex align-items-center justify-content-between"></div>
                                        <Card.Body className="pe-xl-4 ps-0 pe-md-2">
                                          <Box
                                            sx={{
                                              gap: "1rem",
                                              overflow: "auto",
                                              p: "4px",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <MaterialReactTable
                                              table={tableProduct}
                                            />
                                            <Popover
                                              open={dragPopoverOpen}
                                              anchorEl={dragPopoverAnchor}
                                              disableScrollLock={true}
                                              disableAutoFocus={true}
                                              disableEnforceFocus={true}
                                              onClose={() =>
                                                setDragPopoverOpen(false)
                                              }
                                              anchorOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                              }}
                                              transformOrigin={{
                                                vertical: "center",
                                                horizontal: "left",
                                              }}
                                              sx={{
                                                pointerEvents: "none",
                                              }}
                                              PaperProps={{
                                                sx: {
                                                  px: 1.5,
                                                  py: 0.5,
                                                  backgroundColor: "#333",
                                                  color: "white",
                                                  fontSize: "0.75rem",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0px 4px 12px rgba(0,0,0,0.3)",
                                                },
                                              }}
                                            >
                                              <Typography variant="caption">
                                                Drag to move
                                              </Typography>
                                            </Popover>
                                            <Popover
                                              open={
                                                !dragPopoverOpen &&
                                                rowHoverPopoverOpen
                                              }
                                              anchorEl={rowHoverPopoverAnchor}
                                              disableScrollLock={true}
                                              disableAutoFocus={true}
                                              disableEnforceFocus={true}
                                              disableRestoreFocus={true}
                                              onClose={() => {
                                                setRowHoverPopoverOpen(false);
                                                setRowHoverPopoverAnchor(null);
                                                setHoveredRowId(null);
                                                if (hoverTimeoutRef.current) {
                                                  clearTimeout(
                                                    hoverTimeoutRef.current
                                                  );
                                                }
                                              }}
                                              anchorReference="anchorPosition"
                                              anchorPosition={{
                                                top: mousePosition.y - 10,
                                                left: mousePosition.x,
                                              }}
                                              transformOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                              }}
                                              sx={{
                                                pointerEvents: "none",
                                                "& .MuiPaper-root": {
                                                  transform: "translateX(-50%)",
                                                },
                                              }}
                                              PaperProps={{
                                                sx: {
                                                  px: 1.5,
                                                  py: 0.5,
                                                  backgroundColor: "#333",
                                                  color: "white",
                                                  fontSize: "0.75rem",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0px 4px 12px rgba(0,0,0,0.3)",
                                                },
                                              }}
                                            >
                                              <Typography variant="caption">
                                                Click or drag to move
                                              </Typography>
                                            </Popover>
                                          </Box>
                                        </Card.Body>
                                      </>
                                    </div>
                                  </Col>
                                )}

                              <hr className="order-bottom-button" />
                              {(hasImportUpdatePermission ||
                                hasImportDeletePermission ||
                                decodedToken?.roles?.some(
                                  (role) =>
                                    role.role_type === roleTypes.SUPER_ADMIN
                                )) && (
                                  <div className="order-bottom-button justify-content-end align-items-end">
                                    <Button
                                      type="button"
                                      className="btn btn-light me-4"
                                      variant="btn btn-light"
                                      onClick={() => {
                                        handleCancelProduct();
                                        setIsTable2Open(false);
                                      }}
                                    >
                                      Reset
                                    </Button>
                                    <Button
                                      variant="primary"
                                      type="submit"
                                      className="me-4"
                                      disabled={warehouseProductSubmit}
                                    >
                                      Update
                                    </Button>
                                  </div>
                                )}
                            </Row>
                          )}

                          {!viewProduct && !showHistoryView && (
                            <Row>
                              <Col md={12} sm={12} className="m-0 p-0">
                                <Card.Header className="d-flex justify-content-between">
                                  <div className="header-title d-flex">
                                    <h5 className="card-title">
                                      Product{" "}
                                      <span
                                        className="text-gray"
                                        style={{ fontSize: "17px" }}
                                      >
                                        {"(" + selectedItemProduct?.name + ")"}
                                      </span>
                                    </h5>
                                  </div>
                                </Card.Header>

                                <div className="d-flex  align-items-center justify-content-between"></div>
                                <Card.Body className="px-xl-4 px-md-2">
                                  {alerts.show && alerts.alertFor === "product-items" && (
                                    <AlertNotificationSimple
                                      type={alerts.type}
                                      message={alerts.message}
                                      show={alerts.show}
                                      onClose={() => setAlerts({ ...alerts, show: false })}
                                    />
                                  )}
                                  <Box
                                    sx={{
                                      gap: { sm: "0rem" },
                                      overflow: { sm: "auto" },
                                      p: { sm: "4px" },
                                      width: { sm: "100%" },
                                      marginTop: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "3rem",
                                        sm: "3rem",
                                        xs: "0rem",
                                      },
                                    }}
                                  >
                                    <MaterialReactTable
                                      table={tableWarehouseProductItems}
                                      renderTopToolbarCustomActions={() =>
                                        itemsLoader && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              left: "50%",
                                              transform: "translate(-50%, -50%)",
                                              zIndex: 2,
                                            }}
                                          >
                                            <FadeLoaderComponent />
                                          </div>
                                        )
                                      }
                                    />
                                  </Box>
                                </Card.Body>
                              </Col>

                              <hr />
                            </Row>
                          )}

                          {showHistoryView && (
                            <Row>
                              <Col md={12} sm={12} className="m-0 p-0">
                                <Card.Header className="d-flex justify-content-between">
                                  <div className="header-title d-flex">
                                    <h5 className="card-title">
                                      Product{" "}
                                      <span
                                        className="text-gray"
                                        style={{ fontSize: "17px" }}
                                      >
                                        {"(" + selectedItemProduct?.name + ")"}
                                      </span>
                                    </h5>
                                  </div>
                                </Card.Header>

                                <Card.Body className="px-xl-4 px-md-2">
                                  <Box
                                    sx={{
                                      gap: { sm: "0rem" },
                                      overflow: { sm: "auto" },
                                      p: { sm: "4px" },
                                      width: { sm: "100%" },
                                      marginTop: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "3rem",
                                        sm: "3rem",
                                        xs: "0rem",
                                      },
                                    }}
                                  >
                                    <div
                                      style={{
                                        maxHeight: "90vh",
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                        paddingRight: "8px",
                                      }}
                                    >
                                      {selectedHistory &&
                                        selectedHistory.length > 0 ? (
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                          {selectedHistory.map((item) => (
                                            <HistoryCard
                                              key={item.id}
                                              item={item}
                                            />
                                          ))}
                                        </div>
                                      ) : (
                                        <div className="text-center text-muted py-3">
                                          <i className="fas fa-history fa-2x mb-2"></i>
                                          <p>No History Available</p>
                                        </div>
                                      )}
                                    </div>
                                  </Box>
                                </Card.Body>
                              </Col>
                            </Row>
                          )}
                        </Card.Body>
                      )}
                    </Card>
                  </Col>
                </Row>
              </Form>
            )}
          </div>
        )}

      {/* Rack Management Section */}
      {(hasFillProductViewPermission ||
        hasFillProductUpdatePermission ||
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )) && (
          <div>
            {warehouse && (
              <Row>
                <Col sm={12}>
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div
                        className="breadcrumb header-title pb-3  header-title"
                        style={{ cursor: "pointer" }}
                        onClick={toggleCollapseRack}
                      >
                        <h4
                          onClick={() =>
                            navigate("/dashboard/app/warehouse-list")
                          }
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Warehouse</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">Rack Management</h4>
                      </div>
                      <div>
                        {isCollapsedRack ? (
                          <div
                            onClick={toggleCollapseRack}
                            className="sidebar-toggle"
                            style={{
                              position: "initial",
                              marginRight: "1.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="icon"
                              style={{ transform: "rotate(270deg)" }}
                            >
                              <svg
                                width="20"
                                className="icon-20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.25 12.2744L19.25 12.2744"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </i>
                          </div>
                        ) : (
                          <div
                            className="sidebar-toggle"
                            onClick={toggleCollapseRack}
                            style={{
                              position: "initial",
                              marginRight: "1.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="icon"
                              style={{ transform: "rotate(90deg)" }}
                            >
                              <svg
                                width="20"
                                className="icon-20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.25 12.2744L19.25 12.2744"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </i>
                          </div>
                        )}
                      </div>
                    </Card.Header>
                    {!isCollapsedRack && (
                      <Card.Body>
                        <div className="rounded">
                          {/* Header */}
                          <BootstrapCard className="border-0 shadow-sm mb-4">
                            <BootstrapCard.Body className="p-3">
                              <Row className="align-items-center">
                                <Col lg={12}>
                                  <Row className="g-2">
                                    <Col
                                      lg={6}
                                      sm={8}
                                      className="d-flex align-items-center justify-content-end gap-4 gap-xl-8"
                                    >
                                      <div className="position-relative w-100">
                                        <SearchInput
                                          searchQuery={searchTerm}
                                          setSearchQuery={setSearchTerm}
                                          loading={searchLoading}
                                          setLoading={setSearchLoading}
                                        />
                                      </div>
                                      <div className="position-relative w-100">
                                        <Select
                                          closeMenuOnScroll={(e) => {
                                            try {
                                              const target = e.target;

                                              if (
                                                !target ||
                                                !target.nodeType ||
                                                typeof target.closest !==
                                                "function"
                                              ) {
                                                return true;
                                              }

                                              const isMenuScroll =
                                                target.closest(
                                                  '[class*="MenuList"]'
                                                ) ||
                                                target.closest('[class*="menu"]');

                                              return !isMenuScroll;
                                            } catch (error) {
                                              return true;
                                            }
                                          }}
                                          className="w-100"
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          isClearable={false}
                                          isSearchable={false}
                                          isLoading={loading}
                                          isDisabled={loading}
                                          value={statusOptions.find(
                                            (option) =>
                                              option.value === statusFilter
                                          )}
                                          onChange={(selected) => {
                                            setStatusFilter(selected.value);
                                          }}
                                          options={statusOptions}
                                          styles={{
                                            container: (base) => ({
                                              ...base,
                                            }),
                                            control: (provided) => ({
                                              ...provided,

                                              borderRadius: "8px",
                                              borderColor: "#dee2e6",
                                              paddingLeft: "0px",
                                              paddingTop: "3px",
                                              paddingBottom: "3px",
                                              opacity: loading ? 0.7 : 1,
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                            }),
                                            loadingIndicator: (provided) => ({
                                              ...provided,
                                              color: "#6c757d",
                                            }),
                                          }}
                                          components={{
                                            LoadingIndicator: () => (
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  right: "10px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  zIndex: 1,
                                                }}
                                              >
                                                <ThreeDots
                                                  height="20"
                                                  width="20"
                                                  color="#6c757d"
                                                  radius="9"
                                                  ariaLabel="three-dots-loading"
                                                />
                                              </div>
                                            ),
                                          }}
                                        />

                                        {filterLoading && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              right: "40px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              zIndex: 2,
                                            }}
                                          >
                                            <ThreeDots
                                              height="20"
                                              width="20"
                                              color="#6c757d"
                                              radius="9"
                                              ariaLabel="three-dots-loading"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </Col>

                                    <Col
                                      lg={6}
                                      sm={4}
                                      className="d-flex ps-0 ps-sm-4 justify-content-start justify-content-md-end align-items-center"
                                    >
                                      {(rackManagementHasCreatePermission ||
                                        decodedToken?.roles?.some(
                                          (role) =>
                                            role.role_type ===
                                            roleTypes.SUPER_ADMIN
                                        )) && (
                                          <>
                                            <Link
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setShowRackAddModal(true);
                                              }}
                                              className="mt-1 mt-md-0 items-end"
                                            >
                                              <Button
                                                type="submit"
                                                variant="btn btn-primary"
                                                className=" responsive-button"
                                              >
                                                Add New Rack
                                              </Button>
                                            </Link>
                                          </>
                                        )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </BootstrapCard.Body>
                          </BootstrapCard>

                          <Row className="g-3">
                            {displayedRacks?.map((rack) => (
                              <Col key={rack.id} xs={12} sm={6} md={4} lg={3}>
                                <BootstrapCard
                                  className="h-100 rack-card position-relative"
                                  onClick={() => {
                                    if (rack.status === "active") {
                                      handleRackClick(rack);
                                    }
                                  }}
                                  style={{
                                    cursor:
                                      rack.status === "in-active"
                                        ? "not-allowed"
                                        : "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "8px",
                                    backgroundColor: "#FFFFFF",
                                    border: `2px solid ${rack.status === "active"
                                      ? "#10B981"
                                      : "#EF4444"
                                      }`,
                                    overflow: "hidden",
                                    maxWidth: "280px",
                                    margin: "0 auto",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0, 0, 0, 0.15)";
                                    e.currentTarget.style.borderColor =
                                      rack.status === "active"
                                        ? "#059669"
                                        : "#DC2626";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                    e.currentTarget.style.boxShadow =
                                      "0 1px 3px rgba(0, 0, 0, 0.1)";
                                    e.currentTarget.style.borderColor =
                                      rack.status === "active"
                                        ? "#10B981"
                                        : "#EF4444";
                                  }}
                                >
                                  <BootstrapCard.Body className="p-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="rounded me-2 d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                            backgroundColor:
                                              rack.status === "active"
                                                ? "#ECFDF5"
                                                : "#FEF2F2",
                                          }}
                                        >
                                          <Grid3X3
                                            size={16}
                                            style={{
                                              color:
                                                rack.status === "active"
                                                  ? "#10B981"
                                                  : "#EF4444",
                                            }}
                                          />
                                        </div>
                                        <div>
                                          <h6
                                            className="mb-0 fw-semibold"
                                            style={{
                                              color: "#111827",
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            {rack.name.length > 14
                                              ? `${rack.name.slice(0, 14)}...`
                                              : rack.name}
                                          </h6>
                                          <small
                                            className="text-muted"
                                            style={{ fontSize: "0.75rem" }}
                                          >
                                            {rack.rackNumber}
                                          </small>
                                        </div>
                                      </div>

                                      <OverlayTrigger
                                        trigger={["hover", "focus"]}
                                        placement="top"
                                        overlay={
                                          <ReactPopover id="popover-inactive-rack">
                                            <ReactPopover.Body>
                                              Inactive rack. Activate it first to
                                              make changes.
                                            </ReactPopover.Body>
                                          </ReactPopover>
                                        }
                                        show={
                                          rack.status === "in-active"
                                            ? undefined
                                            : false
                                        }
                                      >
                                        <div className="d-inline-block">
                                          <Button
                                            variant="link"
                                            size="sm"
                                            className="p-1 text-muted"
                                            style={{
                                              borderRadius: "4px",
                                              transition: "all 0.2s ease",
                                              opacity:
                                                rack.status === "in-active"
                                                  ? "0.7"
                                                  : "1",
                                              cursor:
                                                rack.status === "in-active"
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            disabled={rack.status === "in-active"}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#F3F4F6";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "transparent";
                                            }}
                                          >
                                            <Edit size={14} />
                                          </Button>
                                        </div>
                                      </OverlayTrigger>
                                    </div>

                                    <div className="mb-2">
                                      <span
                                        className="badge rounded-pill px-2 py-1"
                                        style={{
                                          backgroundColor:
                                            rack.status === "active"
                                              ? "#ECFDF5"
                                              : "#FEF2F2",
                                          color:
                                            rack.status === "active"
                                              ? "#065F46"
                                              : "#991B1B",
                                          fontSize: "0.7rem",
                                          fontWeight: "500",
                                          border: `1px solid ${rack.status === "active"
                                            ? "#10B981"
                                            : "#EF4444"
                                            }`,
                                        }}
                                      >
                                        {getStatusIcon(rack.status, 10)}
                                        <span className="ms-1 text-capitalize">
                                          {rack.status.replace("-", " ")}
                                        </span>
                                      </span>
                                    </div>

                                    <Row className="g-2">
                                      <Col xs={6}>
                                        <div
                                          className="text-center p-2 rounded"
                                          style={{
                                            backgroundColor: "#F8FAFC",
                                            border: "1px solid #E2E8F0",
                                          }}
                                        >
                                          <div
                                            className="h5 mb-0 fw-bold"
                                            style={{
                                              color: "#111827",
                                              fontSize: "1.1rem",
                                            }}
                                          >
                                            {rack.totalRows}
                                          </div>
                                          <small
                                            className="text-muted fw-medium"
                                            style={{ fontSize: "0.7rem" }}
                                          >
                                            Rows
                                          </small>
                                        </div>
                                      </Col>
                                      <Col xs={6}>
                                        <div
                                          className="text-center p-2 rounded"
                                          style={{
                                            backgroundColor: "#F8FAFC",
                                            border: "1px solid #E2E8F0",
                                          }}
                                        >
                                          <div
                                            className="h5 mb-0 fw-bold"
                                            style={{
                                              color: "#111827",
                                              fontSize: "1.1rem",
                                            }}
                                          >
                                            {rack.totalColumns}
                                          </div>
                                          <small
                                            className="text-muted fw-medium"
                                            style={{ fontSize: "0.7rem" }}
                                          >
                                            Columns
                                          </small>
                                        </div>
                                      </Col>
                                    </Row>
                                  </BootstrapCard.Body>
                                </BootstrapCard>
                              </Col>
                            ))}
                          </Row>

                          {filteredRacks?.length === 0 &&
                            (searchTerm !== "" || searchTerm !== null) &&
                            statusFilter !== "all" &&
                            statusFilter !== "active" ? (
                            <div
                              className="d-flex flex-column align-items-center justify-content-center text-center"
                              style={{
                                minHeight: "400px",
                                padding: "2rem",
                              }}
                            >
                              <Package2 className="text-muted mb-3" size={48} />
                              <h5 className="text-dark mb-2">No racks found</h5>
                              <p className="text-muted">
                                Try adjusting your search or filter criteria
                                {(rackManagementHasCreatePermission ||
                                  decodedToken?.roles?.some(
                                    (role) =>
                                      role.role_type === roleTypes.SUPER_ADMIN
                                  )) && (
                                    <>
                                      {" or "}
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setShowRackAddModal(true);
                                        }}
                                        className="text-primary text-decoration-none"
                                        style={{
                                          fontWeight: "500",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Install Racks
                                      </a>
                                    </>
                                  )}
                              </p>
                            </div>
                          ) : (
                            displayedRacks &&
                            displayedRacks?.length === 0 && (
                              <div
                                className="d-flex flex-column align-items-center justify-content-center text-center"
                                style={{
                                  minHeight: "400px",
                                  padding: "2rem",
                                }}
                              >
                                <Package2 className="text-muted mb-3" size={64} />
                                <h4 className="text-dark mb-2">No Racks Found</h4>
                                <p className="text-muted mb-3">
                                  {searchTerm ? (
                                    <>
                                      No racks match your search criteria. Try
                                      adjusting your search terms
                                      {(rackManagementHasCreatePermission ||
                                        decodedToken?.roles?.some(
                                          (role) =>
                                            role.role_type ===
                                            roleTypes.SUPER_ADMIN
                                        )) && (
                                          <>
                                            {statusFilter !== "all" &&
                                              " or filter criteria"}
                                            {" or "}
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setShowRackAddModal(true);
                                              }}
                                              className="text-primary text-decoration-none"
                                              style={{
                                                fontWeight: "500",
                                                cursor: "pointer",
                                              }}
                                            >
                                              Install Racks
                                            </a>
                                          </>
                                        )}
                                    </>
                                  ) : (
                                    <>
                                      There are no racks available in this
                                      warehouse,
                                      {(rackManagementHasCreatePermission ||
                                        decodedToken?.roles?.some(
                                          (role) =>
                                            role.role_type ===
                                            roleTypes.SUPER_ADMIN
                                        )) && (
                                          <>

                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setShowRackAddModal(true);
                                              }}
                                              className="text-primary text-decoration-none"
                                              style={{
                                                fontWeight: "500",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {" "}click here{" "}
                                            </a>
                                            to install some racks
                                          </>
                                        )}
                                    </>
                                  )}
                                </p>
                              </div>
                            )
                          )}
                        </div>
                      </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        )}

      {/* Rack Detail Modal */}
      <Modal
        show={showRackModal}
        onHide={() => setShowRackModal(false)}
        className="custom-modal-rack-width"
        backdrop="true"
        dialogClassName="responsive-modal"
        keyboard={true}
      >
        <Modal.Header className="custom-modal-header">
          <Modal.Title>Rack Information</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            onClick={() => setShowRackModal(false)}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        <Form className="form-horizontal px-3">
          <Modal.Body
            style={{
              padding: "1rem",
              position: "relative",
            }}
          >
            <Row>
              <Col>
                <Form.Group className="form-group mb-2">
                  <div className="p-3 rounded-2">
                    {alerts.alertFor ===
                      "warehouses-rack-bin-edit-products" && (
                        <AlertNotificationSimple
                          type={alerts.type}
                          message={alerts.message}
                          show={alerts.show}
                          onClose={() => setAlerts({ ...alerts, show: false })}
                        />
                      )}
                    {alerts.alertFor === "warehouses-rack-bin-edit" && (
                      <AlertNotificationSimple
                        type={alerts.type}
                        message={alerts.message}
                        show={alerts.show}
                        onClose={() => setAlerts({ ...alerts, show: false })}
                      />
                    )}
                    <p className="text-muted small mb-3">
                      Click on any position to update rack products.
                    </p>

                    {/* Status Legend */}
                    <div
                      className="d-flex align-items-center gap-4 mb-3"
                      style={{ flexFlow: "wrap" }}
                    >
                      <div className="d-flex align-items-center ">
                        <div
                          className="rounded-1 border border-2 border-success me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Active</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2 border-dark me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Inactive</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2 border-danger me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Damage</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-1 border border-2  border-success position-active position-fill me-2"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                        <span className="small text-dark">Fill</span>
                      </div>
                    </div>

                    {/* Grid Container */}
                    <div className="grid-container">
                      <div
                        className="d-grid gap-3"
                        style={{
                          gridTemplateColumns: `repeat(${selectedRack?.totalColumns || 1
                            }, minmax(120px, 1fr))`,
                          justifyContent: "start",
                        }}
                      >
                        {rackBinLoader && <FadeLoaderComponent />}
                        {!rackBinLoader && rackBins && selectedRack && (
                          <div className="d-flex flex-column gap-3">
                            {generateRackBinLayout(
                              rackBins,
                              selectedRack.totalRows,
                              selectedRack.totalColumns
                            )?.map((rowRackBins, rowIndex) => (
                              <div
                                key={rowIndex}
                                className="d-flex gap-2 justify-content-start"
                              >
                                {rowRackBins?.map((rackBin, colIndex) => (
                                  <div
                                    key={`${rowIndex}-${colIndex}`}
                                    className={`
                                  bin-position d-flex flex-column position-relative
                                  ${rackBin.status === "active"
                                        ? "position-active"
                                        : ""
                                      }
                                  ${rackBin.status === "in-active"
                                        ? "position-inactive"
                                        : ""
                                      }
                                  ${rackBin.status === "damaged"
                                        ? "position-damaged"
                                        : ""
                                      }
                                   ${rackBin.productName ? "position-fill" : ""}
                                    `}
                                    onClick={() => {
                                      if (
                                        rackBin.status !== "in-active" &&
                                        rackBin.status !== "damaged" &&
                                        (decodedToken?.roles?.some(
                                          (role) =>
                                            role.role_type ===
                                            roleTypes.SUPER_ADMIN
                                        ) ||
                                          hasFillProductUpdatePermission)
                                      ) {
                                        handleRackBinClick(
                                          rackBin.rowNumber,
                                          rackBin.columnNumber,
                                          rackBin
                                        );
                                      }
                                    }}
                                    title={(() => {
                                      let tooltip = `Row ${rackBin.rowNumber}, Column ${rackBin.columnNumber} - ${rackBin.status}`;
                                      if (rackBin.quantity) {
                                        tooltip += `\nQty: ${rackBin.quantity}`;
                                      }
                                      if (rackBin.productName) {
                                        tooltip += `\n${rackBin.productName}`;
                                      }
                                      return tooltip;
                                    })()}
                                  >
                                    {/* Edit Icon */}
                                    <div className="position-absolute text-primary top-0 end-0 edit-icon-container">
                                      <Link
                                        className={`edit-icon shadow-none ${rackBin.status === "damaged"
                                          ? "text-danger"
                                          : rackBin.status === "in-active"
                                            ? "text-muted "
                                            : "text-primary"
                                          }`}
                                        title={
                                          rackBin.status === "damaged"
                                            ? "Damaged bin"
                                            : rackBin.status === "in-active"
                                              ? "In-active bin"
                                              : "Fill Product"
                                        }
                                      >
                                        {(decodedToken?.roles?.some(
                                          (role) =>
                                            role.role_type ===
                                            roleTypes.SUPER_ADMIN
                                        ) ||
                                          hasFillProductUpdatePermission) &&
                                          rackBin?.status !== "in-active" &&
                                          rackBin?.status !== "damaged" && (
                                            <span className="btn-inner">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="26"
                                                height="26"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-plus-icon lucide-plus"
                                              >
                                                <path d="M5 12h14" />
                                                <path d="M12 5v14" />
                                              </svg>
                                            </span>
                                          )}
                                        {rackBin?.status === "damaged" && (
                                          <AlertCircle
                                            size={16}
                                            className="text-danger"
                                          />
                                        )}

                                        {rackBin?.status === "in-active" && (
                                          <XCircle
                                            size={16}
                                            className="text-black"
                                          />
                                        )}
                                      </Link>
                                    </div>

                                    {/* Content Container with fixed structure */}
                                    <div className="box-content-container gap-1">
                                      <div className="">
                                        <span className="small fw-bold text-dark">
                                          Row{rackBin.rowNumber} Col
                                          {rackBin.columnNumber}
                                        </span>
                                      </div>

                                      {/* Product Name - Fixed height container */}
                                      <div className="product-name-container d-flex flex-column">
                                        <span
                                          className={`product-name ${rackBin.status === "damaged"
                                            ? "text-danger fw-bold"
                                            : rackBin.status === "in-active"
                                              ? "text-muted fw-bold"
                                              : ""
                                            }`}
                                        >
                                          {rackBin.productName
                                            ? rackBin.productName
                                            : rackBin.status === "in-active"
                                              ? "In-active bin"
                                              : rackBin.status === "damaged"
                                                ? "Damaged bin"
                                                : "No Product"}
                                        </span>

                                        {rackBin.quantity ? (
                                          <div className="border-success">
                                            <span className="quantity-text">
                                              Qty: {rackBin.quantity}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="quantity-placeholder"></div>
                                        )}
                                      </div>
                                      <div className=" mt-0 pt-0"></div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
        </Form>
      </Modal>
      <Modal
        show={showDiscardModal}
        onHide={handleCancelDiscard}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
          <Modal.Title>Unsaved Changes</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelDiscard}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className="text-center px-4 pt-2">
          <p
            className="text-muted mb-4 px-2"
            style={{ fontSize: "1rem", lineHeight: "1.5" }}
          >
            You have unsaved changes. You cannot proceed until the selected
            products are updated.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            type="button"
            className="btn btn-white me-4"
            variant="btn btn-white"
            onClick={handleDiscardChanges}
            style={{
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
              borderColor: "#6c757d",
              color: "#6c757d",
            }}
          >
            Discard
          </Button>
          <Button
            className="px-4 py-2"
            style={{
              backgroundColor: "#3a57e8",
              borderColor: "#3a57e8",
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
            }}
            onClick={handleCancelDiscard}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUnsaveModal}
        onHide={handleUnsaveClose}
        centered
        backdrop="static"
        keyboard={false}
        size="md"
      >
        <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative ">
          <Modal.Title>Unsaved Changes</Modal.Title>
          <button
            type="button"
            className="btn-close-svg "
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleUnsaveClose}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        <Modal.Body className="text-center px-4 pt-2">
          <p
            className="text-muted mb-4 px-2"
            style={{ fontSize: "1rem", lineHeight: "1.5" }}
          >
            You have unsaved changes. You cannot proceed until the selected
            products are updated.
          </p>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            type="button"
            className="btn btn-white me-4"
            variant="btn btn-white"
            onClick={async () => {
              setSelectedProductRows([]);
              setWarehouseProducts(oldWarehouseProducts || []);
              if (products && products.length > 0) {
                setProducts((prevProducts) =>
                  prevProducts.map((product) => ({
                    ...product,
                    moved: false,
                    isSelected: false,
                  }))
                );
              }

              setQuantityError(null);
              setMinQuantityError(null);
              setBinError(null);
              setErrors({});
              setIsSubmitProduct(true);
              setWarehouseProductSubmit(false);
              setAnimatingRows(new Set());
              setMovingProducts(new Set());
              setHasUnsavedChanges(false);

              if (selectedWarehouseOption) {
                setType(selectedWarehouseOption);
              } else {
                setType(null);
              }

              handleUnsaveClose();

              if (alertRef.current) {
                alertRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }

              setAlerts({
                message: "Changes discarded successfully",
                type: "success",
                show: true,
                alertFor: "products",
              });

              setTimeout(() => {
                setAlerts({ show: false, alertFor: "", message: "", type: "" });
              }, 2000);

              setSelectedWarehouseOption(null);
            }}
            style={{
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
              borderColor: "#6c757d",
              color: "#6c757d",
            }}
          >
            Discard
          </Button>
          <Button
            onClick={handleUnsaveClose}
            className="px-4 py-2"
            style={{
              backgroundColor: "#3a57e8",
              borderColor: "#3a57e8",
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
            }}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showRackBinModal}
        onHide={() => setShowRackBinModal(false)}
        backdrop="true"
        keyboard={true}
      >
        <Modal.Header className="custom-modal-header">
          <div>
            <Modal.Title>Fill Product into Bin</Modal.Title>
            <small className="text-muted">
              Inside (Row {selectedRackBin?.row}, Column {selectedRackBin?.col})
            </small>
          </div>
          <button
            type="button"
            className="btn-close-svg"
            onClick={() => setShowRackBinModal(false)}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        {/* Body */}

        <Modal.Body>
          {/* Product Selection */}
          {productRackBinLoader && <FadeLoaderComponent />}
          {!productRackBinLoader && (
            <>
              <div className="mb-3">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="product" className="mb-2">
                    Products
                  </Form.Label>

                  {selectedProduct && selectedProduct?.label !== null && (
                    <div className="mb-3">
                      <div className="position-relative">
                        {/* Product Card */}
                        <div
                          className="card border-0 shadow-sm position-relative overflow-hidden"
                          style={{
                            background:
                              "linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%)",
                            borderRadius: "12px",
                            border: "1px solid #e3f2fd",
                          }}
                        >
                          {/* Decorative background pattern */}
                          <div
                            className="position-absolute top-0 end-0 opacity-10"
                            style={{
                              width: "100px",
                              height: "100px",
                              background:
                                "radial-gradient(circle, #667eea 0%, transparent 70%)",
                              transform: "translate(30px, -30px)",
                            }}
                          ></div>

                          <div className="card-body p-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center flex-grow-1">
                                {/* Icon */}
                                <div
                                  className="me-3 d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "44px",
                                    height: "44px",
                                    backgroundColor: "#667eea",
                                    borderRadius: "10px",
                                    boxShadow:
                                      "0 2px 8px rgba(102, 126, 234, 0.3)",
                                  }}
                                >
                                  <Package className="text-white" size={20} />
                                </div>

                                {/* Product Info */}
                                <div className="flex-grow-1">
                                  <h6 className="mb-0 fw-semibold text-dark">
                                    {selectedProduct?.label}
                                  </h6>
                                  <small className="text-muted">
                                    Row {selectedRackBin?.row}, Column{" "}
                                    {selectedRackBin?.col}
                                  </small>
                                </div>
                              </div>

                              {/* Remove Button */}
                              <button
                                type="button"
                                className="btn btn-sm ms-2 position-relative"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
                                  border: "none",
                                  borderRadius: "8px",
                                  width: "32px",
                                  height: "32px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  boxShadow:
                                    "0 2px 6px rgba(255, 107, 107, 0.3)",
                                  transition: "all 0.2s ease",
                                }}
                                onClick={() => {
                                  setSelectedProduct(null);
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.transform = "scale(1.05)";
                                  e.target.style.boxShadow =
                                    "0 4px 12px rgba(255, 107, 107, 0.4)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.transform = "scale(1)";
                                  e.target.style.boxShadow =
                                    "0 2px 6px rgba(255, 107, 107, 0.3)";
                                }}
                                title="Remove current product"
                              >
                                ×
                              </button>
                            </div>
                          </div>

                          {/* Status indicator */}
                          <div
                            className="position-absolute top-0 start-0"
                            style={{
                              width: "4px",
                              height: "100%",
                              backgroundColor: "#667eea",
                              borderRadius: "12px 0 0 12px",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}

                  <Select
                    closeMenuOnScroll={(e) => {
                      try {
                        const target = e.target;

                        if (
                          !target ||
                          !target.nodeType ||
                          typeof target.closest !== "function"
                        ) {
                          return true;
                        }

                        const isMenuScroll =
                          target.closest('[class*="MenuList"]') ||
                          target.closest('[class*="menu"]');

                        return !isMenuScroll;
                      } catch (error) {
                        return true;
                      }
                    }}
                    id="product"
                    options={optionProducts}
                    value={
                      optionProducts.find(
                        (opt) => opt.value === selectedProduct?.value
                      ) ?? null
                    }
                    onChange={(option) => {
                      setSelectedProduct(option ?? null);
                    }}
                    isDisabled={
                      !(
                        decodedToken?.roles.some(
                          (role) => role.role_type === roleTypes.SUPER_ADMIN
                        ) || hasFillProductUpdatePermission
                      )
                    }
                    isClearable={false}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    noOptionsMessage={() => "No product found"}
                    placeholder="Select a product to assign..."
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "100%",
                      }),
                      control: (provided) => ({
                        ...provided,
                        color: "#5e667b",
                        minHeight: "38px",
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </Form.Group>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            variant="btn btn-danger"
            onClick={() => setShowRackBinModal(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="btn btn-primary"
            disabled={
              !isSubmitRack ||
              !(
                decodedToken?.roles.some(
                  (role) => role.role_type === roleTypes.SUPER_ADMIN
                ) || hasFillProductUpdatePermission
              )
            }
            onClick={async () => {
              if (isSubmitRack) {
                setIsSubmitRack(false);
                await handleAssignProduct();
                setIsSubmitRack(true);
              }
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showRackAddModal}
        onHide={() => setShowRackAddModal(false)}
        backdrop="true"
        className="custom-modal-create-rack-width"
        keyboard={true}
      >
        <Modal.Header className="custom-modal-header">
          <Modal.Title>Create Rack</Modal.Title>

          <button
            type="button"
            className="btn-close-svg"
            onClick={() => setShowRackAddModal(false)}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        {showRackAddModal && (
          <RackAdd
            id={id}
            warehouseName={warehouse && warehouse?.name}
            showRackAddModal={showRackAddModal}
            handleSubmitAddRack={handleSubmitAddRack}
            setShowRackAddModal={setShowRackAddModal}
          />
        )}
      </Modal>
    </>
  );
};

export default WarehouseEdit;
